
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fImWv", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $da002f83cf061f88$export$d0aef4d352cf8b14 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ctj29",
    name: "AnalyticsByLine",
    loader: async ()=>(await (parcelRequire("lwpgR"))).AnalyticsByLine
});
module.exports["AnalyticsByLine"] = $da002f83cf061f88$export$d0aef4d352cf8b14;

});

parcelRegister("lwpgR", function(module, exports) {

let $fab03068c120e62a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fab03068c120e62a$var$load("6wr18"),
    $fab03068c120e62a$var$load("4RHRd"),
    $fab03068c120e62a$var$load("PcK4a"),
    $fab03068c120e62a$var$load("6XCf4"),
    $fab03068c120e62a$var$load("ebvEF"),
    $fab03068c120e62a$var$load("ffEVr"),
    $fab03068c120e62a$var$load("jqoep"),
    $fab03068c120e62a$var$load("7EorR"),
    $fab03068c120e62a$var$load("aEiTV"),
    $fab03068c120e62a$var$load("hhss7"),
    $fab03068c120e62a$var$load("1qlDN"),
    $fab03068c120e62a$var$load("1yVM6"),
    $fab03068c120e62a$var$load("6c9wI")
]).then(()=>parcelRequire('ffp8s'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("a9SX7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $db22052f45cd3c08$export$aeb07f2d59756a1b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VfqBC",
    name: "ListenByline",
    loader: async ()=>(await (parcelRequire("hJraL"))).ListenByline
});
module.exports["ListenByline"] = $db22052f45cd3c08$export$aeb07f2d59756a1b;

});

parcelRegister("hJraL", function(module, exports) {

let $ce8bb7879337be3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ce8bb7879337be3d$var$load("8TYN0"),
    $ce8bb7879337be3d$var$load("bb3WM"),
    $ce8bb7879337be3d$var$load("5lo9L")
]).then(()=>parcelRequire('lFyOr'));

});

parcelRegister("8h2Hn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $aonKu = parcelRequire("aonKu");


const $a20c7295ece9229b$export$867b5e5ad0743f37 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AzA78",
    name: "BylineConnections",
    loader: async ()=>(await (parcelRequire("he6b6"))).BylineConnections,
    loading: (0, $aonKu.BylineConnectionsPlaceholder)
});
module.exports["BylineConnections"] = $a20c7295ece9229b$export$867b5e5ad0743f37;

});

parcelRegister("aonKu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fZLJ8 = parcelRequire("fZLJ8");





var $kSwu1 = parcelRequire("kSwu1");


var $9Ktxh = parcelRequire("9Ktxh");


var $jJhQa = parcelRequire("jJhQa");


var $f0mzK = parcelRequire("f0mzK");

const $25cd036cbf182d70$var$i18n = (0, $kSwu1.defineMessages)({
    loadingConnections: {
        id: "byline-connections.loading",
        defaultMessage: "Loading connections"
    }
});
const $25cd036cbf182d70$export$3914fbcb8a4d6407 = ({ testId: testId = 'byline-connections-ssr-placeholder', iconCount: iconCount = (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS) })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const placeholderIcons = (0, $cozmU.useMemo)(()=>Array.from({
            length: Math.min(Math.max(iconCount, 0), (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS))
        }, (_, index)=>(0, $f0mzK.createPlaceholderConnectionIcon)(index)), [
        iconCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Ktxh.BylineConnectionsWrapper), {
        appearance: "placeholder",
        role: "status",
        "aria-label": formatMessage($25cd036cbf182d70$var$i18n.loadingConnections),
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Ktxh.BylineConnectionsTrigger), {
        appearance: "placeholder",
        links: [],
        additionalIcons: placeholderIcons
    }));
};



var $3C8hL = parcelRequire("3C8hL");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6U179 = parcelRequire("6U179");


var $47TZD = parcelRequire("47TZD");

// Passed only while the read is skipped, so the exact value never keys a real cache lookup.
const $c1244bdd1b458e82$var$SKIPPED_VARIABLES = {
    cypherQuery: '',
    first: 0
};
const $c1244bdd1b458e82$export$36c53bcdf571f79b = (contentId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const variables = !contentId || !cloudId ? undefined : (0, $47TZD.buildIncomingLinksSampleVariables)(cloudId, contentId);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $6U179.default), {
        variables: variables ?? $c1244bdd1b458e82$var$SKIPPED_VARIABLES,
        fetchPolicy: 'cache-only',
        skip: variables === undefined,
        interopApolloAggClient: true,
        __callerPackage__: "byline-connections"
    });
    // An undefined `variables` forces `skip`, which forces `data` undefined, so the `data` guard
    // already covers it; the `contentId` guard also narrows it to a string for the normalizer.
    if (!contentId || data === undefined) return undefined;
    return (0, $47TZD.normalizeIncomingLinksSsrState)(contentId, data);
};



var $6Ybng = parcelRequire("6Ybng");

const $d13ffa3aaf9dd66c$export$f8ba3742be6a3e0d = ({ contentId: contentId, connectionAncestors: connectionAncestors })=>{
    // Read the preloaded outbound state on the client too (cache-only, hydrated from the SSR
    // preload). This lets the placeholder stay visible after the post-paint hydration and while the
    // LoadableAfterPaint chunk loads, instead of blanking — which caused the "SSR placeholder →
    // nothing → skeleton → item" flash. The result is derived purely from the hydrated cache and
    // dev-docs, so it is identical on the server and the client's first render (no hydration
    // mismatch). Pages with no connections still render nothing (no client footprint). CCINT-8752
    const outboundState = (0, $6Ybng.useOutboundBylineSsrState)(contentId);
    const incomingLinksState = (0, $c1244bdd1b458e82$export$36c53bcdf571f79b)(contentId);
    const devDocsConnection = (0, $fZLJ8.useDevDocsBylineConnection)(connectionAncestors);
    // Strictly conservative: render only on a positive signal, so a page with nothing to show keeps
    // no footprint. An 'unavailable' outbound result is not a signal.
    const hasOutboundSignal = outboundState?.status === 'present' || devDocsConnection !== null;
    if (!hasOutboundSignal) {
        // Inbound-only: with no outbound smart-link or Dev Docs signal, render the logo-and-label
        // placeholder (no app icon tiles) when the bounded inbound sample found incoming
        // connections. This matches the inbound-only FE trigger, whose app icon stack is empty
        // (BylineConnectionIconStack returns null for zero links). Any other inbound state — empty,
        // unavailable, or a cache miss — keeps zero footprint. CCINT-8932
        if (incomingLinksState?.status === 'present') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $25cd036cbf182d70$export$3914fbcb8a4d6407), {
            testId: "byline-connections-ssr-placeholder",
            iconCount: 0
        });
        return null;
    }
    const iconCount = (0, $3C8hL.getReservedBylineIconCount)(outboundState, devDocsConnection !== null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $25cd036cbf182d70$export$3914fbcb8a4d6407), {
        testId: "byline-connections-ssr-placeholder",
        iconCount: iconCount
    });
};
module.exports["BylineConnectionsPlaceholder"] = $d13ffa3aaf9dd66c$export$f8ba3742be6a3e0d;

});

parcelRegister("9Ktxh", function(module, exports) {
/* BylineConnectionsTrigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $aZ9If = parcelRequire("aZ9If");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $hTfX9 = parcelRequire("hTfX9");

const $55dbae87bfebb50e$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "byline-connections.label",
        defaultMessage: "Context"
    }
});
const $55dbae87bfebb50e$var$styles = {
    wrapper: "_2sNsIg7NXe _3iDTPbccYA _0hPCNLDIqT _2xTnZx1Y8M _0jFU0VoWWg _1ANEUSzUZr",
    wrapperLoaded: "_1UtDYzZpcK",
    wrapperPlaceholder: "_1UtDYzot27",
    trigger: "_2sNsIg7NXe _0bjKvDKxmn _4FKVYE1Y8M _3iDTPbccYA _0hPCNLDIqT _17lj8p1Y8M _0KLXrujOvk _1ANEUSLRg7",
    triggerLoaded: "_0wOv4Q7zJH _1UtDYzZpcK _1eOmH6o126 _3gzVzLN4oS",
    triggerPlaceholder: "_0wOv4QOLYo _1UtDYzot27"
};
const $55dbae87bfebb50e$export$8b56d9356350e1f6 = ({ appearance: appearance, children: children, ...htmlAttributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ...htmlAttributes,
        className: (0, $hekY6.default)([
            $55dbae87bfebb50e$var$styles.wrapper,
            appearance === 'loaded' ? $55dbae87bfebb50e$var$styles.wrapperLoaded : $55dbae87bfebb50e$var$styles.wrapperPlaceholder
        ])
    }, children);
const $55dbae87bfebb50e$export$a5631cafd5b67535 = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { additionalIcons: additionalIcons, appearance: appearance, links: links, minIcons: minIcons } = props;
    const isPlaceholder = appearance === 'placeholder';
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ9If))), {
        label: "",
        size: "small",
        color: isPlaceholder ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)",
        testId: "byline-connections-teamwork-graph-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        size: "small",
        color: isPlaceholder ? 'color.text.disabled' : 'color.text.subtle'
    }, formatMessage($55dbae87bfebb50e$var$i18n.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTfX9.BylineConnectionIconStack), {
        links: links,
        additionalIcons: additionalIcons,
        appearance: isPlaceholder ? 'placeholder' : 'default',
        minIcons: minIcons,
        spacing: "none"
    }));
    if (props.appearance === 'placeholder') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        isDisabled: true,
        "aria-hidden": "true",
        testId: "byline-connections-trigger",
        xcss: (0, $w6R6I.cx)($55dbae87bfebb50e$var$styles.trigger, $55dbae87bfebb50e$var$styles.triggerPlaceholder)
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ...props.buttonProps,
        testId: "byline-connections-trigger",
        xcss: (0, $w6R6I.cx)($55dbae87bfebb50e$var$styles.trigger, $55dbae87bfebb50e$var$styles.triggerLoaded)
    }, content);
};
module.exports["BylineConnectionsWrapper"] = $55dbae87bfebb50e$export$8b56d9356350e1f6;
module.exports["BylineConnectionsTrigger"] = $55dbae87bfebb50e$export$a5631cafd5b67535;

});

parcelRegister("hTfX9", function(module, exports) {
/* BylineConnectionIconStack.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $38aC9 = parcelRequire("38aC9");


var $jJhQa = parcelRequire("jJhQa");


var $f0mzK = parcelRequire("f0mzK");

const $a9443aed03d2e255$var$styles = {
    stack: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC _2YgrGrP0S5",
    spacingBefore: "_0GTcwR1Y8M",
    spacingAfter: "_2xTnZx1Y8M"
};
const $a9443aed03d2e255$var$appIconTileStyles = null;
const $a9443aed03d2e255$var$glyphTileStyles = null;
const $a9443aed03d2e255$var$placeholderIconTileStyles = null;
const $a9443aed03d2e255$var$firstIconTileStyles = null;
const $a9443aed03d2e255$var$secondIconTileStyles = null;
const $a9443aed03d2e255$var$thirdIconTileStyles = null;
const $a9443aed03d2e255$var$isAtlasKitAppLogo = (icon)=>icon.icon.kind === 'logo';
const $a9443aed03d2e255$export$de98155121ad78a4 = ({ links: links, additionalIcons: additionalIcons, appearance: appearance = 'default', minIcons: minIcons, spacing: spacing = 'after' })=>{
    const realIcons = (0, $cozmU.useMemo)(()=>(0, $jJhQa.getBylineConnectionIcons)(links, additionalIcons), [
        links,
        additionalIcons
    ]);
    const icons = (0, $cozmU.useMemo)(()=>{
        const target = Math.min(minIcons ?? 0, (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS));
        if (realIcons.length >= target) return realIcons;
        const padding = Array.from({
            length: target - realIcons.length
        }, (_, index)=>(0, $f0mzK.createPlaceholderConnectionIcon)(realIcons.length + index, appearance));
        return [
            ...realIcons,
            ...padding
        ];
    }, [
        realIcons,
        minIcons,
        appearance
    ]);
    if (icons.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": "byline-connections-icon-stack",
        className: (0, $hekY6.default)([
            $a9443aed03d2e255$var$styles.stack,
            spacing === 'before' && $a9443aed03d2e255$var$styles.spacingBefore,
            spacing === 'after' && $a9443aed03d2e255$var$styles.spacingAfter
        ])
    }, icons.map((icon, index)=>{
        const isPlaceholderTile = appearance === 'placeholder';
        const useAppChrome = !isPlaceholderTile && $a9443aed03d2e255$var$isAtlasKitAppLogo(icon);
        const chip = useAppChrome ? 'app' : 'glyph';
        switch(index){
            case 0:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    key: icon.key,
                    "data-chip": chip,
                    className: (0, $hekY6.default)([
                        useAppChrome ? "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc" : "_0bjKvDKxmn _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc",
                        isPlaceholderTile && "_3vBAKHhQC5 _0KLXruVrZW",
                        "_42Yu6BPvK5"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
                    icon: icon.icon,
                    size: "stack"
                }));
            case 1:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    key: icon.key,
                    "data-chip": chip,
                    "data-rotation-enabled": true,
                    className: (0, $hekY6.default)([
                        useAppChrome ? "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc" : "_0bjKvDKxmn _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc",
                        isPlaceholderTile && "_3vBAKHhQC5 _0KLXruVrZW",
                        "_0GTcwR5UaJ _42Yu6Bbhqd _2AERac9ub0"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
                    icon: icon.icon,
                    size: "stack"
                }));
            case 2:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    key: icon.key,
                    "data-chip": chip,
                    className: (0, $hekY6.default)([
                        useAppChrome ? "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc" : "_0bjKvDKxmn _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc",
                        isPlaceholderTile && "_3vBAKHhQC5 _0KLXruVrZW",
                        "_0GTcwR5UaJ _42Yu6BgtVO"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
                    icon: icon.icon,
                    size: "stack"
                }));
            default:
                return null;
        }
    }));
};
module.exports["BylineConnectionIconStack"] = $a9443aed03d2e255$export$de98155121ad78a4;

});

parcelRegister("38aC9", function(module, exports) {
/* SmartLinkIconRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kTb7m = parcelRequire("kTb7m");

const $034a9b0def7554d2$var$baseStyles = null; // Image icons fill their wrapper; the wrapper carries the desired pixel size.
const $034a9b0def7554d2$var$imgStyles = null; // Stack chips keep third-party product images at 10px inside the 16px glyph tile, matching
// the pre-app-icon byline. Menu rows keep the 16px face.
const $034a9b0def7554d2$var$imageStyles = {
    stack: "_39xV02uFDC _0jFU0VuFDC",
    menu: "_39xV02ey7F _0jFU0Vey7F"
}; // AtlasKit React-element icons (@atlaskit/icon, @atlaskit/object) render an <svg> at a fixed
// intrinsic 16px that ignores the wrapper size, so we render at that natural size and scale the
// whole composed icon down with a centred transform — this shrinks any element icon uniformly
// without distorting or clipping it. 16px -> 10px in the stack; the menu keeps the natural size.
const $034a9b0def7554d2$var$elementStyles = {
    stack: "_39xV02ey7F _0jFU0Vey7F _46hvQmFQfX _1VJPcaGquZ _0yKXXaDIqT",
    menu: "_39xV02ey7F _0jFU0Vey7F"
}; // Product logos already include a branded tile. AtlasKit IconWrapper is `inline-block`, so the
// SVG sits on a line box and looks high in the chip. The slot is a flex container and the
// wrapper span is also flex so the logo centres on both axes.
const $034a9b0def7554d2$var$logoStyles = {
    stack: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02N91d _0jFU0VN91d _4ouGXIdnbC _4kiQYAdnbC _4ya3eEdnbC _4v6ugQQ4SZ _1XJ99dDIqT _3NACppDIqT",
    menu: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _39xV02oWWg _0jFU0VoWWg _4ouGXIdnbC _4kiQYAdnbC _3YEZNOdnbC _4ya3eEdnbC _4v6ugQQ4SZ _1XJ99dDIqT _3NACppDIqT"
};
// surfaces as the browser's "broken image" glyph. <img> load failures aren't caught by React error
// boundaries — they only surface through the DOM `onError` event — so we attach `onError` to the
// <img> at the point it's created here and swap in a neutral link icon on failure.
const $034a9b0def7554d2$var$ImageIcon = ({ src: src, size: size })=>{
    const [hasErrored, setHasErrored] = (0, $cozmU.useState)(false); // Reset when the source changes — the menu reuses one renderer instance across rows.
    (0, $cozmU.useEffect)(()=>{
        setHasErrored(false);
    }, [
        src
    ]);
    if (hasErrored) // The fallback is an <svg> element icon, so it uses the element wrapper (which applies the
    // stack scale-down / menu natural-size logic) rather than the image wrapper.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
            $034a9b0def7554d2$var$elementStyles[size]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
            $034a9b0def7554d2$var$imageStyles[size]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: "",
        src: src,
        onError: ()=>setHasErrored(true),
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _00EA0egIor"
        ])
    }));
};
const $034a9b0def7554d2$export$24f3a21bb86b5d0c = ({ icon: icon, size: size })=>{
    if (icon.kind === 'image') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($034a9b0def7554d2$var$ImageIcon, {
        src: icon.src,
        size: size
    });
    if (icon.kind === 'logo') {
        const logoNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(icon.node, {
            size: size === 'stack' ? 'xxsmall' : 'small'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true",
            "data-testid": "smart-link-logo",
            className: (0, $hekY6.default)([
                $034a9b0def7554d2$var$logoStyles[size]
            ])
        }, logoNode);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
            $034a9b0def7554d2$var$elementStyles[size]
        ])
    }, icon.node);
};
module.exports["SmartLinkIconRenderer"] = $034a9b0def7554d2$export$24f3a21bb86b5d0c;

});

parcelRegister("6Ybng", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $66MEr = parcelRequire("66MEr");


var $3C8hL = parcelRequire("3C8hL");

const $4fdcf8c799fd8a14$export$4ec68330314c7b96 = (contentId)=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $66MEr.default), {
        variables: {
            contentId: contentId ?? ''
        },
        fetchPolicy: 'cache-only',
        skip: contentId === undefined,
        __callerPackage__: "byline-connections"
    });
    if (contentId === undefined || data === undefined) return undefined;
    return (0, $3C8hL.normalizeOutboundBylineSsrState)(contentId, data);
};
module.exports["useOutboundBylineSsrState"] = $4fdcf8c799fd8a14$export$4ec68330314c7b96;

});

parcelRegister("he6b6", function(module, exports) {

let $c8a8894b56a2db24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c8a8894b56a2db24$var$load("1N1yt"),
    $c8a8894b56a2db24$var$load("5He1y"),
    $c8a8894b56a2db24$var$load("hESIs"),
    $c8a8894b56a2db24$var$load("9A059"),
    $c8a8894b56a2db24$var$load("Lm7SH"),
    $c8a8894b56a2db24$var$load("7SteV"),
    $c8a8894b56a2db24$var$load("Q7rDv"),
    $c8a8894b56a2db24$var$load("2BqMU"),
    $c8a8894b56a2db24$var$load("arqPY"),
    $c8a8894b56a2db24$var$load("7EorR"),
    $c8a8894b56a2db24$var$load("ce05o"),
    $c8a8894b56a2db24$var$load("6e4fH"),
    $c8a8894b56a2db24$var$load("jxB64"),
    $c8a8894b56a2db24$var$load("6wr18"),
    $c8a8894b56a2db24$var$load("Wowvf"),
    $c8a8894b56a2db24$var$load("hhss7"),
    $c8a8894b56a2db24$var$load("7gL7H"),
    $c8a8894b56a2db24$var$load("52ZTT"),
    $c8a8894b56a2db24$var$load("9VG8E"),
    $c8a8894b56a2db24$var$load("bLZ3r"),
    $c8a8894b56a2db24$var$load("h6m7t"),
    $c8a8894b56a2db24$var$load("aLwQm"),
    $c8a8894b56a2db24$var$load("ffEVr"),
    $c8a8894b56a2db24$var$load("1SVGS"),
    $c8a8894b56a2db24$var$load("dwQ9M"),
    $c8a8894b56a2db24$var$load("6zCMk"),
    $c8a8894b56a2db24$var$load("80Yra"),
    $c8a8894b56a2db24$var$load("d1n8n"),
    $c8a8894b56a2db24$var$load("aeeja")
]).then(()=>parcelRequire('l2a4I'));

});

parcelRegister("aKxcs", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<b75dcd816ce4b8bd73313cd50a946812>>
 * @relayHash 5d29dbb06afa46621e34f49131b3f839
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f47dc690f4d212f9c3ec615c12da22fb42b20f4278924ecd25cbbba4d12671c
const $64132a3f8ab78d31$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BylineClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BylineClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "5d29dbb06afa46621e34f49131b3f839",
            "id": "1f47dc690f4d212f9c3ec615c12da22fb42b20f4278924ecd25cbbba4d12671c",
            "metadata": {},
            "name": "BylineClassificationQuery",
            "operationKind": "query",
            "text": "query BylineClassificationQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{id,title,operations{operation,targetType},space{id,name,key,alias},type,status}}}"
        }
    };
}();
$64132a3f8ab78d31$var$node.hash = "e42e71a5c3870b4bc1b88d032b366270";
var $64132a3f8ab78d31$export$2e2bcd8739ae039 = $64132a3f8ab78d31$var$node;


/**
 * @generated SignedSource<<161eb8de8e725ca0b3b4b39ce9a07b04>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $87d62e4cd7f32dc5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "BylineClassification_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "operation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            },
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "alias"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "useContentClassification_content"
            }
        ],
        "type": "Content"
    };
}();
$87d62e4cd7f32dc5$var$node.hash = "b485efc177facaa2fb781adacdeaa29e";
var $87d62e4cd7f32dc5$export$2e2bcd8739ae039 = $87d62e4cd7f32dc5$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $jMyy4 = parcelRequire("jMyy4");


var $cuWTe = parcelRequire("cuWTe");


var $1ggpj = parcelRequire("1ggpj");


var $iiPY2 = parcelRequire("iiPY2");


var $knzfV = parcelRequire("knzfV");


var $1u6lx = parcelRequire("1u6lx");


var $bFMG7 = parcelRequire("bFMG7");





var $b3j2Y = parcelRequire("b3j2Y");


var $jjv3l = parcelRequire("jjv3l");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");

const $5278cea226e8a354$export$84b0a317f0d2e2ff = (0, $87d62e4cd7f32dc5$export$2e2bcd8739ae039);
const $5278cea226e8a354$export$5dc05a3e9ee4399c = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { contentId: contentId, classificationContextFragmentRef: classificationContextFragmentRef, contentFragmentRef: contentFragmentRef } = t0;
    if (classificationContextFragmentRef && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_classification_context_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
        let t1;
        if ($[0] !== classificationContextFragmentRef || $[1] !== contentId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationContextFragmentReader, {
                contentId: contentId,
                contentFragmentRef: classificationContextFragmentRef
            });
            $[0] = classificationContextFragmentRef;
            $[1] = contentId;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== contentFragmentRef || $[4] !== contentId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationLegacyQueryReader, {
            contentId: contentId,
            contentFragmentRef: contentFragmentRef
        });
        $[3] = contentFragmentRef;
        $[4] = contentId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $5278cea226e8a354$var$BylineClassificationContextFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { contentId: contentId, contentFragmentRef: contentFragmentRef } = t0;
    const contentData = (0, $6SsN4.useFragment)($5278cea226e8a354$export$84b0a317f0d2e2ff, contentFragmentRef);
    const readerProps = $5278cea226e8a354$var$useBylineClassificationReaderProps(contentId, contentData);
    let t1;
    if ($[0] !== contentData || $[1] !== contentId || $[2] !== readerProps.contentStatusContext) {
        t1 = {
            contentId: contentId,
            contentFragmentRef: contentData,
            contentStatusContext: readerProps.contentStatusContext,
            shouldReadFromQueries: true
        };
        $[0] = contentData;
        $[1] = contentId;
        $[2] = readerProps.contentStatusContext;
        $[3] = t1;
    } else t1 = $[3];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassificationFromFragment)(t1);
    let t2;
    if ($[4] !== contentClassificationMetadata || $[5] !== readerProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationContent, {
            ...readerProps,
            contentClassificationMetadata: contentClassificationMetadata
        });
        $[4] = contentClassificationMetadata;
        $[5] = readerProps;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $5278cea226e8a354$var$BylineClassificationLegacyQueryReader = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { contentId: contentId, contentFragmentRef: contentFragmentRef } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: bylineClassificationQueryError } = (0, $jMyy4.useQueryInterop)((0, $64132a3f8ab78d31$export$2e2bcd8739ae039), {
        ...t1,
        __callerPackage__: "content-header"
    });
    const contentData = data?.content?.nodes?.[0];
    const readerProps = $5278cea226e8a354$var$useBylineClassificationReaderProps(contentId, contentData);
    if (bylineClassificationQueryError) {
        let t2;
        if ($[2] !== bylineClassificationQueryError) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: bylineClassificationQueryError
            });
            $[2] = bylineClassificationQueryError;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    if (contentFragmentRef && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_meta_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
        let t2;
        if ($[4] !== contentFragmentRef || $[5] !== readerProps) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationMetadataFragmentReader, {
                ...readerProps,
                contentFragmentRef: contentFragmentRef
            });
            $[4] = contentFragmentRef;
            $[5] = readerProps;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    }
    let t2;
    if ($[7] !== readerProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationMetadataQueryReader, readerProps);
        $[7] = readerProps;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
const $5278cea226e8a354$var$useBylineClassificationReaderProps = (contentId, contentData)=>{
    const $ = (0, $bDgLe.c)(19);
    const isExternal = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const rawContentType = contentData?.type ?? undefined;
    const isArchived = contentData?.status === "archived";
    const isDraft = contentData?.status === "draft";
    const isViewEditOrLive = (0, $aSsfA.useGetPageMode)();
    let t0;
    if ($[0] !== isArchived || $[1] !== isDraft || $[2] !== isViewEditOrLive || $[3] !== rawContentType) {
        t0 = (0, $cuWTe.getContentMode)(rawContentType, isArchived, isDraft, isViewEditOrLive) || isViewEditOrLive || (0, $cD1qu.PageMode).VIEW;
        $[0] = isArchived;
        $[1] = isDraft;
        $[2] = isViewEditOrLive;
        $[3] = rawContentType;
        $[4] = t0;
    } else t0 = $[4];
    const contentMode = t0;
    let t1;
    if ($[5] !== contentMode || $[6] !== rawContentType) {
        t1 = {
            type: rawContentType,
            mode: contentMode
        };
        $[5] = contentMode;
        $[6] = rawContentType;
        $[7] = t1;
    } else t1 = $[7];
    const contentType = t1;
    let contentStatusContext;
    if (contentType.mode === "live" || contentType.mode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false)) contentStatusContext = "current-and-draft";
    else if (contentType.mode === "edit" || contentType.mode === "draft") contentStatusContext = "draft-only";
    else contentStatusContext = "current-only";
    const t2 = contentData?.space?.key || "";
    const t3 = contentData?.space?.key;
    let t4;
    if ($[8] !== contentType.mode) {
        t4 = contentType.mode === (0, $cD1qu.PageMode).VIEW && !(0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false);
        $[8] = contentType.mode;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== contentData || $[11] !== contentId || $[12] !== contentStatusContext || $[13] !== contentType || $[14] !== isExternal || $[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
        t5 = {
            contentId: contentId,
            spaceKey: t2,
            spaceKeyOverride: t3,
            contentData: contentData,
            contentType: contentType,
            contentStatusContext: contentStatusContext,
            isExternal: isExternal,
            isViewModeReadOnly: t4
        };
        $[10] = contentData;
        $[11] = contentId;
        $[12] = contentStatusContext;
        $[13] = contentType;
        $[14] = isExternal;
        $[15] = t2;
        $[16] = t3;
        $[17] = t4;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
};
const $5278cea226e8a354$var$BylineClassificationMetadataQueryReader = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let contentId;
    let props;
    let spaceKeyOverride;
    if ($[0] !== t0) {
        ({ contentId: contentId, spaceKeyOverride: spaceKeyOverride, ...props } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = props;
        $[3] = spaceKeyOverride;
    } else {
        contentId = $[1];
        props = $[2];
        spaceKeyOverride = $[3];
    }
    let t1;
    if ($[4] !== contentId || $[5] !== props.contentStatusContext || $[6] !== spaceKeyOverride) {
        t1 = {
            contentId: contentId,
            spaceKeyOverride: spaceKeyOverride,
            contentStatusContext: props.contentStatusContext,
            shouldReadFromQueries: true
        };
        $[4] = contentId;
        $[5] = props.contentStatusContext;
        $[6] = spaceKeyOverride;
        $[7] = t1;
    } else t1 = $[7];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)(t1);
    let t2;
    if ($[8] !== contentClassificationMetadata || $[9] !== contentId || $[10] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationContent, {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata,
            ...props
        });
        $[8] = contentClassificationMetadata;
        $[9] = contentId;
        $[10] = props;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
};
const $5278cea226e8a354$var$BylineClassificationMetadataFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let contentFragmentRef;
    let contentId;
    let props;
    if ($[0] !== t0) {
        ({ contentId: contentId, contentFragmentRef: contentFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = contentFragmentRef;
        $[2] = contentId;
        $[3] = props;
    } else {
        contentFragmentRef = $[1];
        contentId = $[2];
        props = $[3];
    }
    let t1;
    if ($[4] !== contentFragmentRef || $[5] !== contentId || $[6] !== props.contentStatusContext) {
        t1 = {
            contentId: contentId,
            contentFragmentRef: contentFragmentRef,
            contentStatusContext: props.contentStatusContext,
            shouldReadFromQueries: true
        };
        $[4] = contentFragmentRef;
        $[5] = contentId;
        $[6] = props.contentStatusContext;
        $[7] = t1;
    } else t1 = $[7];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassificationFromFragment)(t1);
    let t2;
    if ($[8] !== contentClassificationMetadata || $[9] !== contentId || $[10] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationContent, {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata,
            ...props
        });
        $[8] = contentClassificationMetadata;
        $[9] = contentId;
        $[10] = props;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
};
const $5278cea226e8a354$var$BylineClassificationContent = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { contentId: contentId, spaceKey: spaceKey, contentData: contentData, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, isExternal: isExternal, isViewModeReadOnly: isViewModeReadOnly } = t0;
    let t1;
    if ($[0] !== contentClassificationMetadata.isReclassificationPermitted || $[1] !== contentData?.operations) {
        t1 = (0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false) ? contentClassificationMetadata.isReclassificationPermitted ?? false : contentData?.operations?.some($5278cea226e8a354$var$_temp);
        $[0] = contentClassificationMetadata.isReclassificationPermitted;
        $[1] = contentData?.operations;
        $[2] = t1;
    } else t1 = $[2];
    const hasUpdatePermission = t1;
    const readOnly = isExternal || !hasUpdatePermission || isViewModeReadOnly;
    const isClassificationEnabled = contentClassificationMetadata.featureEnabled ?? false;
    let t2;
    if ($[3] !== contentClassificationMetadata || $[4] !== contentId || $[5] !== contentType || $[6] !== isClassificationEnabled || $[7] !== readOnly || $[8] !== spaceKey) {
        t2 = isClassificationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iiPY2.ContentTypeClassificationLoader), {
            variant: (0, $1u6lx.TagButtonUIVariant).default,
            spaceKey: spaceKey,
            contentId: contentId,
            contentType: contentType.type ?? "",
            contentClassificationMetadata: contentClassificationMetadata,
            readOnly: readOnly,
            spacing: "expanded"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knzfV.ClassificationEditModal), {
            contentId: contentId,
            spaceKey: spaceKey,
            contentClassificationMetadata: contentClassificationMetadata
        })) : null;
        $[3] = contentClassificationMetadata;
        $[4] = contentId;
        $[5] = contentType;
        $[6] = isClassificationEnabled;
        $[7] = readOnly;
        $[8] = spaceKey;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
};
function $5278cea226e8a354$var$_temp(operation) {
    return operation?.targetType && (0, $1ggpj.VALID_OPERATION_TARGETS).includes(operation.targetType) && operation.operation === "update";
}
module.exports["BylineClassification"] = $5278cea226e8a354$export$5dc05a3e9ee4399c;

});

parcelRegister("6iOCg", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kmQhR = parcelRequire("kmQhR");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $1LXnB = parcelRequire("1LXnB");


var $jVylI = parcelRequire("jVylI");


var $aV3a0 = parcelRequire("aV3a0");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $jjv3l = parcelRequire("jjv3l");


var $6mKj3 = parcelRequire("6mKj3");


var $gektR = parcelRequire("gektR");


var $e4o8D = parcelRequire("e4o8D");


var $1xpoY = parcelRequire("1xpoY");








var $8wW9d = parcelRequire("8wW9d");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");

const $e105dde0a43b3be2$export$b613c53a0aeac846 = (contentId)=>{
    const $ = (0, $bDgLe.c)(15);
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    const { webItems: connectItems, loading: loadingConnectItems, error: connectError } = (0, $6ld6a.useWebItemLocation)(t0);
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
        };
        $[2] = t1;
    } else t1 = $[2];
    const { extensions: forgeItems, loading: loadingForgeItems, error: forgeError } = (0, $3b6WO.useExtensionList)(t1);
    let t2;
    let t3;
    if ($[3] !== connectItems || $[4] !== forgeItems) {
        t2 = ()=>{
            (0, $8wW9d.recordNonContentAppKeys)("byline", [
                ...connectItems?.map($e105dde0a43b3be2$var$_temp) ?? [],
                ...forgeItems?.map($e105dde0a43b3be2$var$_temp2) ?? []
            ]);
        };
        t3 = [
            connectItems,
            forgeItems
        ];
        $[3] = connectItems;
        $[4] = forgeItems;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = connectItems?.length > 0 || forgeItems?.length > 0;
    let t5;
    if ($[7] !== connectError || $[8] !== connectItems || $[9] !== forgeError || $[10] !== forgeItems || $[11] !== loadingConnectItems || $[12] !== loadingForgeItems || $[13] !== t4) {
        t5 = {
            hasApps: t4,
            connectItems: connectItems,
            loadingConnectItems: loadingConnectItems,
            connectError: connectError,
            forgeItems: forgeItems,
            loadingForgeItems: loadingForgeItems,
            forgeError: forgeError
        };
        $[7] = connectError;
        $[8] = connectItems;
        $[9] = forgeError;
        $[10] = forgeItems;
        $[11] = loadingConnectItems;
        $[12] = loadingForgeItems;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
};
function $e105dde0a43b3be2$var$_temp(item) {
    return item.completeKey;
}
function $e105dde0a43b3be2$var$_temp2(item_0) {
    return item_0.id;
}



var $j2moL = parcelRequire("j2moL");


var $35Exc = parcelRequire("35Exc");








var $kSwu1 = parcelRequire("kSwu1");


var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");


var $1sCHt = parcelRequire("1sCHt");


var $3izAL = parcelRequire("3izAL");


var $kh0hi = parcelRequire("kh0hi");




const $120e402a2d601a31$var$i18n = (0, $kSwu1.defineMessages)({
    showAllApps: {
        id: "content-header.livepages.by-line.showAllApps",
        defaultMessage: "Show all apps"
    },
    showLessApps: {
        id: "content-header.livepages.by-line.showLess",
        defaultMessage: "Show less"
    }
});
const $120e402a2d601a31$var$toggleButtonGradientStyles = (0, $buxP3.xcss)({
    height: '100%',
    position: 'relative',
    '::before': {
        content: '""',
        background: `linear-gradient(to right, transparent, ${"var(--ds-surface, #FFFFFF)"})`,
        height: '100%',
        left: 'space.negative.400',
        position: 'absolute',
        width: '32px'
    }
});
const $120e402a2d601a31$var$buttonStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: "var(--ds-radius-small, 4px)",
    color: 'color.text.subtle',
    display: 'flex',
    font: 'font.body.small',
    gap: 'space.075',
    padding: 'space.050',
    paddingInlineStart: 'space.075',
    paddingInlineEnd: 'space.075',
    whiteSpace: 'nowrap',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $120e402a2d601a31$export$a2051cde2c49a6fb = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { isExpanded: isExpanded, handleToggle: handleToggle } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const t1 = !isExpanded && $120e402a2d601a31$var$toggleButtonGradientStyles;
    let t2;
    if ($[0] !== handleToggle || $[1] !== intl || $[2] !== isExpanded) {
        t2 = !isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: $120e402a2d601a31$var$_temp,
            label: intl.formatMessage($120e402a2d601a31$var$i18n.showAllApps),
            onClick: handleToggle,
            testId: "show-all-apps-button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: $120e402a2d601a31$var$buttonStyles,
            onClick: handleToggle,
            testId: "show-less-apps-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
            label: "",
            size: "small"
        }), intl.formatMessage($120e402a2d601a31$var$i18n.showLessApps));
        $[0] = handleToggle;
        $[1] = intl;
        $[2] = isExpanded;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t1,
            testId: "single-line-byline-toggle-wrapper"
        }, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
function $120e402a2d601a31$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        ...iconProps,
        size: "small"
    });
}



var $3aDMt = parcelRequire("3aDMt");


var $87We3 = parcelRequire("87We3");

const $202654fe0d7532c2$var$singleLineBaseStyles = (0, $buxP3.xcss)({
    whiteSpace: 'nowrap',
    width: '100%',
    overflowX: 'hidden'
});
const $202654fe0d7532c2$var$appsContainerStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    gap: 'space.050',
    overflow: 'hidden'
});
const $202654fe0d7532c2$var$bylineContentStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    gap: 'space.050'
});
const $202654fe0d7532c2$var$singleLineWrapStyles = (0, $buxP3.xcss)({
    flexWrap: 'wrap',
    overflowX: 'visible'
});
const $202654fe0d7532c2$var$centerAlignmentStyles = (0, $buxP3.xcss)({
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 'initial'
});
const $202654fe0d7532c2$var$maxWidthStyles = (0, $buxP3.xcss)({
    maxWidth: '760px'
});
// when the last byline app is on the first row of the byline, its top position should be within this offset
// this is assuming no byline items are wrapping themselves (which they shouldn't be)
const $202654fe0d7532c2$var$BYLINE_SINGLE_ROW_TOP_OFFSET = 15;
const $202654fe0d7532c2$var$AppsContainer = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $202654fe0d7532c2$var$appsContainerStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $202654fe0d7532c2$export$cc95b64079434472 = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, children: children, contentType: contentType = 'page', isTitleCenterAlignedOverride: isTitleCenterAlignedOverride, showByLineExtensions: showByLineExtensions = true })=>{
    const bylineAppsDefaultCollapsed = (0, $1xpoY.default).getBoolean('confluence_byline_app_default_collapsed', false);
    const [shouldShowToggleButton, setShouldShowToggleButton] = (0, $cozmU.useState)(false);
    const [haveAppsLoaded, setHaveAppsLoaded] = (0, $cozmU.useState)(false);
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(!bylineAppsDefaultCollapsed);
    const [currentParentWidth, setCurrentParentWidth] = (0, $cozmU.useState)();
    const isRestrictedExternalShare = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const bylineRef = (0, $cozmU.useRef)(null);
    const { isTitleCenteredInitial: isTitleCenteredInitial } = (0, $aV3a0.useTitleContentPropertiesForEditor)({
        contentId: contentId,
        contentType: contentType
    });
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { hasApps: hasApps, connectItems: connectItems, connectError: connectError, forgeItems: forgeItems, forgeError: forgeError, loadingConnectItems: loadingConnectItems, loadingForgeItems: loadingForgeItems } = (0, $e105dde0a43b3be2$export$b613c53a0aeac846)(contentId);
    const [initialSnapshot] = (0, $cozmU.useState)(()=>{
        if (!renderServerPlaceholder || isRestrictedExternalShare || !showByLineExtensions || !(0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)) return {
            contentId: contentId,
            snapshot: undefined
        };
        // Enrolled loads have already paid the preload cost, so they remain exposed even when
        // an incomplete result prevents the snapshot from being rendered.
        const snapshot = (0, $87We3.createByLineAppSnapshot)({
            connectError: connectError,
            connectItems: connectItems,
            forgeError: forgeError,
            forgeItems: forgeItems,
            loadingConnectItems: loadingConnectItems,
            loadingForgeItems: loadingForgeItems
        });
        // Keep the server/mount-time presentation immutable while the client queries refresh.
        return {
            contentId: contentId,
            snapshot: (0, $87We3.isByLineAppSnapshotAuthoritative)(snapshot) ? snapshot : undefined
        };
    });
    const isInitialSnapshotRetired = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        // This snapshot belongs only to the initial hydration. Once another page commits,
        // never make it eligible again if SPA navigation later returns to the initial page.
        if (initialSnapshot.snapshot && contentId !== initialSnapshot.contentId) isInitialSnapshotRetired.current = true;
    }, [
        contentId,
        initialSnapshot
    ]);
    const authoritativeSnapshot = !isInitialSnapshotRetired.current && initialSnapshot.contentId === contentId ? initialSnapshot.snapshot : undefined;
    (0, $cozmU.useEffect)(()=>{
        if (!bylineRef.current || !haveAppsLoaded) return;
        const bylineAppsRoot = authoritativeSnapshot && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? bylineRef.current.querySelector('[data-byline-app-runtime]') : bylineRef.current;
        if (!bylineAppsRoot) return;
        const forgeApps = Array.from(bylineAppsRoot.querySelectorAll('[data-testid="forge-byline-header-wrapper"]'));
        const webItemApps = Array.from(bylineAppsRoot.querySelectorAll('[data-testid="web-item-link"]'));
        // forge items are rendered after web items so theyd be last if rendered
        const appsList = [
            ...webItemApps,
            ...forgeApps
        ];
        const lastAppElement = appsList[appsList.length - 1];
        if (!lastAppElement) return;
        const bylineRefRect = bylineRef.current?.getBoundingClientRect();
        const lastAppRect = lastAppElement.getBoundingClientRect();
        const areOnSameLine = Math.abs(bylineRefRect.top - lastAppRect.top) < $202654fe0d7532c2$var$BYLINE_SINGLE_ROW_TOP_OFFSET;
        if (isExpanded) {
            // theres no need to calculate overflow below if the apps are already expanded
            // we just need to check if all apps fit in the first row so we can hide the toggle button
            setShouldShowToggleButton(!areOnSameLine);
            return;
        }
        // Check if elements are on the same line by comparing their top positions
        setShouldShowToggleButton(lastAppRect.right > bylineRefRect.right);
    }, [
        authoritativeSnapshot,
        currentParentWidth,
        haveAppsLoaded,
        isExpanded
    ]);
    const toggleShowAllApps = ()=>{
        setIsExpanded((currentState)=>!currentState);
    };
    const handleBylineAppsLoaded = (0, $cozmU.useCallback)(()=>{
        setHaveAppsLoaded(true);
    }, []);
    const updateContentAreaWidth = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))((width)=>{
        setCurrentParentWidth(width);
    }, 100);
    // this container is necessary to prevent the byline overflow from pushing the show more button out of view
    const RestrictAppsInOverflowContainer = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment : $202654fe0d7532c2$var$AppsContainer;
    const shouldShowApps = !isRestrictedExternalShare && (hasApps || Boolean(authoritativeSnapshot?.apps.length)) && showByLineExtensions;
    const bylineApps = renderServerPlaceholder && window.__SSR_REACT_STREAMING__ ? authoritativeSnapshot && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aDMt.AuthoritativeByLineApps), {
        snapshot: authoritativeSnapshot
    }) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j2moL.LazyLivePagesByLineApps), {
        contentId: contentId,
        connectItems: connectItems,
        forgeItems: forgeItems,
        forgeError: forgeError,
        showLivePagesExtensionPoints: true,
        isSingleLineByline: true,
        onBylineAppsLoaded: handleBylineAppsLoaded,
        loadingConnectItems: loadingConnectItems,
        loadingForgeItems: loadingForgeItems,
        noContainer: true,
        authoritativeSnapshot: authoritativeSnapshot
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gektR.AlignmentButtonContainer)
        ]
    }, (alignmentButtonContainer)=>{
        const isTitleCenterAligned = isTitleCenterAlignedOverride || (!alignmentButtonContainer.state.isLoadingComplete ? isTitleCenteredInitial : alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).CENTER);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35Exc.BylineStyledMainDivSingleLine), {
            isExpanded: isExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            testId: "byline-single-line",
            ref: bylineRef,
            xcss: [
                $202654fe0d7532c2$var$singleLineBaseStyles,
                // show more toggles to enable wrap are dependent on having apps present
                // this would prevent an edge case of a very long byline (or tiny viewport) with no apps being cut off
                (isExpanded || !shouldShowApps) && $202654fe0d7532c2$var$singleLineWrapStyles,
                isTitleCenterAligned && $202654fe0d7532c2$var$centerAlignmentStyles,
                isTitleCenterAligned && !isExpanded && $202654fe0d7532c2$var$maxWidthStyles
            ],
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $6mKj3.expValEquals)('confluence_skip_byline_apps_placeholder', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $202654fe0d7532c2$var$bylineContentStyles
        }, children) : children, shouldShowApps && bylineApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RestrictAppsInOverflowContainer, null, bylineApps)) : null), renderServerPlaceholder && window.__SSR_REACT_STREAMING__ ? null : shouldShowApps && shouldShowToggleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $120e402a2d601a31$export$a2051cde2c49a6fb), {
            isExpanded: isExpanded,
            handleToggle: toggleShowAllApps
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
            setWidth: updateContentAreaWidth
        }));
    });
});
module.exports["SingleLineByLine"] = $202654fe0d7532c2$export$cc95b64079434472;

});

parcelRegister("j2moL", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $6mKj3 = parcelRequire("6mKj3");


var $80koo = parcelRequire("80koo");


var $b3j2Y = parcelRequire("b3j2Y");


var $7Sm4c = parcelRequire("7Sm4c");


var $jmjWc = parcelRequire("jmjWc");











var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");

const $5ea8d19a294b60fd$var$containerStyles = null;
const $5ea8d19a294b60fd$var$hiddenStyles = (0, $buxP3.xcss)({
    opacity: 0
});
const $5ea8d19a294b60fd$var$dynamicLineStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.skeleton',
    height: '12px',
    borderRadius: 'radius.small',
    display: 'inline-block',
    marginRight: 'space.250'
});
const $5ea8d19a294b60fd$var$forgeLineStyles = (0, $buxP3.xcss)({
    width: '62px' // px taken from original placeholder
});
const $5ea8d19a294b60fd$var$placeholderWrapperStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    display: 'flex',
    height: '24px'
});
const $5ea8d19a294b60fd$export$1196cbdc07fcbaba = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { connectItems: connectItems, forgeItems: forgeItems, noContainer: t1 } = t0;
    const noContainer = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== connectItems || $[1] !== forgeItems || $[2] !== noContainer) {
        t2 = noContainer ? [
            ...connectItems,
            ...forgeItems
        ].map($5ea8d19a294b60fd$var$_temp) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "live-pages-byline-apps-loading",
            className: (0, $hekY6.default)([
                "_3iDTPbccYA"
            ])
        }, [
            ...connectItems,
            ...forgeItems
        ].map($5ea8d19a294b60fd$var$_temp2));
        $[0] = connectItems;
        $[1] = forgeItems;
        $[2] = noContainer;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
function $5ea8d19a294b60fd$var$_temp(item, index) {
    const isForgeItem = !!item?.properties?.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        testId: "live-pages-byline-app-placeholder",
        key: index,
        xcss: $5ea8d19a294b60fd$var$placeholderWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: isForgeItem ? [
            $5ea8d19a294b60fd$var$dynamicLineStyles,
            $5ea8d19a294b60fd$var$forgeLineStyles
        ] : $5ea8d19a294b60fd$var$dynamicLineStyles,
        testId: isForgeItem ? "forge-placeholder" : "connect-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $5ea8d19a294b60fd$var$hiddenStyles
    }, item?.label)));
}
function $5ea8d19a294b60fd$var$_temp2(item_0, index_0) {
    const isForgeItem_0 = !!item_0?.properties?.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: isForgeItem_0 ? [
            $5ea8d19a294b60fd$var$dynamicLineStyles,
            $5ea8d19a294b60fd$var$forgeLineStyles
        ] : $5ea8d19a294b60fd$var$dynamicLineStyles,
        key: index_0,
        testId: isForgeItem_0 ? "forge-placeholder" : "connect-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $5ea8d19a294b60fd$var$hiddenStyles
    }, item_0?.label));
}












var $ah4BL = parcelRequire("ah4BL");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");


var $asQED = parcelRequire("asQED");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");




/**
 * @generated SignedSource<<146f014633927f394ddf960a506da573>>
 * @relayHash 7c8317bb717346ea2ddd7f2fdb49f2d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c54ae82f4f2aaf407e36724c9a56ad7521ffa4ac52a827b9d418240e4a5d4b7
const $25c03fd7fde92d1a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "InvokeExtensionResponse",
            "kind": "LinkedField",
            "name": "invokeExtension",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "InvocationResponsePayload",
                    "kind": "LinkedField",
                    "name": "response",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "body"
                        }
                    ]
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "statusCode"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "BulkMutationErrorExtension"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ByLineForgeAppinvokeExtensionMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ByLineForgeAppinvokeExtensionMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7c8317bb717346ea2ddd7f2fdb49f2d0",
            "id": "4c54ae82f4f2aaf407e36724c9a56ad7521ffa4ac52a827b9d418240e4a5d4b7",
            "metadata": {},
            "name": "ByLineForgeAppinvokeExtensionMutation",
            "operationKind": "mutation",
            "text": "mutation ByLineForgeAppinvokeExtensionMutation($input:InvokeExtensionInput!){invokeExtension(input:$input){success,response{body},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$25c03fd7fde92d1a$var$node.hash = "00321bd07f93db1aae1039ee5a2af686";
var $25c03fd7fde92d1a$export$2e2bcd8739ae039 = $25c03fd7fde92d1a$var$node;


/**
 * @generated SignedSource<<c17c93bf1426cb7bad9e9fd690e6df41>>
 * @relayHash 3c4f64826d7984a1b9ffd5e33ca9912a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 35786eea47e3b38990a83407ce21c733ad1ca087cd7fe7c0a4546f97b1f75da4
const $7d674aec1e0705be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ByLineForgeAppGeneralContentPropertyQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ByLineForgeAppGeneralContentPropertyQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "3c4f64826d7984a1b9ffd5e33ca9912a",
            "id": "35786eea47e3b38990a83407ce21c733ad1ca087cd7fe7c0a4546f97b1f75da4",
            "metadata": {},
            "name": "ByLineForgeAppGeneralContentPropertyQuery",
            "operationKind": "query",
            "text": "query ByLineForgeAppGeneralContentPropertyQuery($contentId:ID!){content(id:$contentId){nodes{id,properties{nodes{id,key,version{number},value}}}}}"
        }
    };
}();
$7d674aec1e0705be$var$node.hash = "08bea7ea10f693c30b7a4dcf7cfc95e0";
var $7d674aec1e0705be$export$2e2bcd8739ae039 = $7d674aec1e0705be$var$node;








var $9aYkv = parcelRequire("9aYkv");


var $kSwu1 = parcelRequire("kSwu1");


var $4n1IT = parcelRequire("4n1IT");


var $kh0hi = parcelRequire("kh0hi");





var $lpNn5 = parcelRequire("lpNn5");


var $lfoFx = parcelRequire("lfoFx");








var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $aF5bm = parcelRequire("aF5bm");


var $4vC63 = parcelRequire("4vC63");


var $7QUD1 = parcelRequire("7QUD1");


var $lOI2p = parcelRequire("lOI2p");


var $jYZsR = parcelRequire("jYZsR");


var $hIaUw = parcelRequire("hIaUw");


var $grspz = parcelRequire("grspz");


var $8a9Dm = parcelRequire("8a9Dm");


var $9fBoq = parcelRequire("9fBoq");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7W8i8 = parcelRequire("7W8i8");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $jMyy4 = parcelRequire("jMyy4");


var $1JyKZ = parcelRequire("1JyKZ");


var $308Wd = parcelRequire("308Wd");


var $e5xte = parcelRequire("e5xte");




var $46f2a733fab59ac5$exports = {};
$46f2a733fab59ac5$exports = new URL("AK_AddonIcon.7997ef8d.svg", import.meta.url).toString();



var $83fWZ = parcelRequire("83fWZ");

// Type for content property value structure
// Utility function to check if a value is a non-empty string
const $3b594b06ac9b7376$var$isNonEmptyString = (value)=>{
    return typeof value === 'string' && value.trim() !== '';
};
// Utility function to validate and set a byline content property value
const $3b594b06ac9b7376$var$validatePropertyValue = (key, value, validatedProperties)=>{
    if (value !== undefined) {
        if ($3b594b06ac9b7376$var$isNonEmptyString(value)) validatedProperties[key] = value;
        else // eslint-disable-next-line no-console
        console.warn(`Byline content property ${key} must be a non-empty string, got:`, typeof value);
    }
};
// Validation function for extracting property node from GraphQL query data
const $3b594b06ac9b7376$var$validateContentPropertyQuery = (data, contentPropertyKey)=>{
    // Check if data exists and has the expected structure
    if (!data || !data.content || !data.content.nodes || data.content.nodes.length === 0 || !data.content.nodes[0].properties || !data.content.nodes[0].properties.nodes || data.content.nodes[0].properties.nodes.length === 0) {
        // eslint-disable-next-line no-console
        console.warn('Invalid byline content property query data');
        return null;
    }
    // Get all objects that match the contentPropertyKey
    const properties = data.content.nodes[0].properties.nodes;
    const contentKeyPattern = new RegExp(contentPropertyKey);
    const matchingObjects = properties.filter((property)=>contentKeyPattern.test(property.key ?? ''));
    if (matchingObjects.length === 0) {
        // eslint-disable-next-line no-console
        console.warn('No property nodes matching content property key pattern found');
        return null;
    }
    if (matchingObjects.length > 1) {
        // eslint-disable-next-line no-console
        console.warn('Multiple property nodes matching content property key pattern found. Please make sure your contentPropertyKey is unique, like a UUID.');
        return null;
    }
    const propertyNode = matchingObjects[0];
    const validContentPropertyKey = propertyNode.key;
    if (!propertyNode.value) {
        // eslint-disable-next-line no-console
        console.warn('Byline content property data has no value');
        return null;
    }
    return {
        propertyNode: propertyNode,
        validContentPropertyKey: validContentPropertyKey
    };
};
// Common function to validate title, icon, and tooltip properties
const $3b594b06ac9b7376$var$validateProperties = (propertyValue, validatedProperties)=>{
    // validate each property
    $3b594b06ac9b7376$var$validatePropertyValue('title', propertyValue.title, validatedProperties);
    $3b594b06ac9b7376$var$validatePropertyValue('icon', propertyValue.icon, validatedProperties);
    $3b594b06ac9b7376$var$validatePropertyValue('tooltip', propertyValue.tooltip, validatedProperties);
};
const $3b594b06ac9b7376$export$48cf1be175912dd = (data, defaultValues)=>{
    try {
        // Validate and extract the query data
        const queryResult = $3b594b06ac9b7376$var$validateContentPropertyQuery(data, defaultValues.contentPropertyKey);
        if (!queryResult) return defaultValues;
        const { propertyNode: propertyNode, validContentPropertyKey: validContentPropertyKey } = queryResult;
        // Parse JSON with error handling
        let propertyValue;
        try {
            propertyValue = JSON.parse(propertyNode.value ?? '');
        } catch (jsonError) {
            // eslint-disable-next-line no-console
            console.error('Failed to parse byline content property JSON:', jsonError);
            return defaultValues;
        }
        // Validate the structure of the parsed value
        if (typeof propertyValue !== 'object' || propertyValue === null) {
            // eslint-disable-next-line no-console
            console.error('Byline content property value is not an object:', propertyValue);
            return defaultValues;
        }
        const validatedProperties = {
            ...defaultValues
        };
        // Validate each property using the byline content property value utility function
        $3b594b06ac9b7376$var$validateProperties(propertyValue, validatedProperties);
        if (validContentPropertyKey && validContentPropertyKey !== '') validatedProperties.contentPropertyKey = validContentPropertyKey;
        return validatedProperties;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Unexpected error in content property validation:', error);
        return defaultValues;
    }
};
const $3b594b06ac9b7376$export$96933cae6933ce51 = (eventData, defaultValues)=>{
    try {
        // Check if eventData exists and has the expected structure
        if (!eventData || !eventData.propertyKey || !eventData.valueUpdate) {
            // eslint-disable-next-line no-console
            console.warn('Invalid FORGE_CONTENT_PROPERTY_UPDATED event data structure');
            return defaultValues;
        }
        const valueUpdate = eventData.valueUpdate;
        // Validate the structure of valueUpdate
        if (typeof valueUpdate !== 'object' || valueUpdate === null) {
            // eslint-disable-next-line no-console
            console.error('Event valueUpdate is not an object:', valueUpdate);
            return defaultValues;
        }
        const validatedProperties = {
            ...defaultValues
        };
        $3b594b06ac9b7376$var$validateProperties(valueUpdate, validatedProperties);
        return validatedProperties;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Unexpected error in event data validation:', error);
        return defaultValues;
    }
};


const $1cb9b1bda2de2c04$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_BYLINE_FORGE_EXPERIENCE); // General content property query for reading all content properties
const $1cb9b1bda2de2c04$var$GENERAL_CONTENT_PROPERTY_QUERY = (0, $7d674aec1e0705be$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1cb9b1bda2de2c04$var$ContentWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEkG2W _1EqgXl4DOi _0NUa3r4DOi _2WAcuGIZbP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $1cb9b1bda2de2c04$var$i18n = (0, $kSwu1.defineMessages)({
    appIcon: {
        id: "content-header.forge.byline-app.app-icon-alt",
        defaultMessage: "App Icon"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1cb9b1bda2de2c04$var$ByLineForgeAppHeaderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "span" : t2;
        const { isHidden: isHidden, ...__cmpldp } = __cmplp;
        const t3 = __cmplp.isHidden ? "none" : "inline-block";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_z2o4qt": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_3iDTPb3qsO _0adFHsPgdg _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0z71MC98eZ _4tUF3yYbGa _0a2Gmi6wH8 _0ReiIH7zJH",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $1cb9b1bda2de2c04$var$Image = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "img" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEn1Zi _0jFU0VEbN9 _39xV02EbN9 _3iDTPbvbI6 _1RrJLiYXK7 _1UtDYz8ujp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $1cb9b1bda2de2c04$var$forgeAppButtonStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.small',
    display: 'inline-flex',
    font: 'font.body.small',
    color: 'color.text.subtle',
    gap: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    marginRight: 'space.0',
    padding: 'space.050',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        textDecoration: 'none'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $1cb9b1bda2de2c04$var$forgeAppButtonDotStyles = (0, $buxP3.xcss)({
    '::before': {
        content: '"\u2022"',
        display: 'inline-block',
        paddingRight: 'space.050',
        alignSelf: 'center',
        textDecoration: 'none'
    }
});
const $1cb9b1bda2de2c04$var$sharedForgeAppButtonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    display: 'inline-flex',
    padding: 'space.0'
});
const $1cb9b1bda2de2c04$var$ByLineForgeAppTrigger = ({ app: app, reference: reference, defineTriggerRef: defineTriggerRef, toggleClose: toggleClose, isOpen: isOpen, extensionData: extensionData, isHidden: isHidden, hideDot: hideDot, appTitle: appTitle, setAppTitle: setAppTitle, hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const appHasDynamicProperties = !!app.properties.dynamicProperties;
    const [contentPropertyKey, setContentPropertyKey] = (0, $cozmU.useState)(app.properties.contentPropertyKey || '');
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const workspaceARI = (0, $aF5bm.useWorkspaceARI)();
    const [appIcon, setAppIcon] = (0, $cozmU.useState)(app.properties.icon || null);
    const [appTooltip, setAppTooltip] = (0, $cozmU.useState)(app.properties.tooltip || null);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(appHasDynamicProperties);
    const localId = (0, $cozmU.useMemo)(()=>(0, $grspz.getLocalId)(app.id), [
        app.id
    ]);
    const getContextToken = (0, $1JyKZ.useGetContextToken)({
        extension: app,
        extensionData: extensionData,
        localId: localId,
        contextIds: [
            workspaceARI
        ]
    });
    const getContextTokenRef = (0, $cozmU.useRef)(getContextToken);
    (0, $cozmU.useEffect)(()=>{
        getContextTokenRef.current = getContextToken;
    }, [
        getContextToken
    ]);
    const [bylineDynamicPropertiesMutation] = (0, $308Wd.useMutationInterop)((0, $25c03fd7fde92d1a$export$2e2bcd8739ae039), {
        interopApolloAggClient: true,
        __callerPackage__: "content-header"
    });
    const fetchDynamicProperties = (0, $cozmU.useCallback)(async ()=>{
        const extensionId = app.id;
        const contextPayload = {
            cloudId: cloudId,
            localId: localId,
            extension: extensionData
        };
        let contextToken;
        try {
            contextToken = await getContextTokenRef.current();
        } catch (e) {
            throw new Error(`Failed to get context token: ${e}`);
        }
        const result = await bylineDynamicPropertiesMutation({
            variables: {
                input: {
                    entryPoint: 'dynamicProperties',
                    contextIds: [
                        workspaceARI
                    ],
                    extensionId: extensionId,
                    payload: {
                        context: contextPayload,
                        ...contextPayload,
                        // TODO: This is temporary for Forge apps' backward compatibility
                        ...contextToken ? {
                            contextToken: contextToken
                        } : {}
                    }
                }
            }
        }).catch((e)=>{
            return {
                data: {
                    invokeExtension: {
                        success: false,
                        errors: [
                            {
                                message: e
                            }
                        ]
                    }
                }
            };
        });
        setIsLoading(false); // @ts-expect-error The types here are a bit messy. Typegen for AGG should help solve that
        const { response: response, success: success } = result.data?.invokeExtension; // @ts-expect-error The types here are a bit messy. Typegen for AGG should help solve that
        const errors = result.data?.invokeExtension.errors;
        if (!success) {
            const logger = (0, $7W8i8.getLogger)('by-line-apps');
            const errorMessages = errors.map((error)=>error.message).join(' '); // prints error to aid forge developer && allow Ecosystem to track these errors
            logger.error`Failed to fetch dynamic properties for ByLine Forge app: ${app.id} with error: ${errorMessages}`;
            if (errorMessages !== 'User consent required') (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Failed to fetch dynamic properties for ByLine Forge app: ${app.id} with error: ${errorMessages}`), {
                attribution: (0, $3IBnw.Attribution).ECOSYSTEM
            });
            return;
        }
        if (response.body) {
            const { body: { title: dynamicPropsTitle, tooltip: dynamicPropsTooltip, icon: dynamicPropsIcon } } = response;
            dynamicPropsTitle && setAppTitle((0, $9fBoq.extensionTitle)(app, dynamicPropsTitle));
            dynamicPropsTooltip && setAppTooltip(dynamicPropsTooltip);
            dynamicPropsIcon && setAppIcon(dynamicPropsIcon);
        }
    }, [
        app,
        cloudId,
        extensionData,
        bylineDynamicPropertiesMutation,
        workspaceARI,
        setAppTitle,
        localId
    ]);
    // Validation function for content property data
    const validateContentPropertyDataCallback = (0, $cozmU.useCallback)((data)=>{
        const defaultValues = {
            title: appTitle,
            icon: app.properties.icon || '',
            tooltip: app.properties.tooltip || '',
            contentPropertyKey: app.properties.contentPropertyKey || ''
        };
        return (0, $3b594b06ac9b7376$export$48cf1be175912dd)(data, defaultValues);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []); // Validation function specifically for FORGE_CONTENT_PROPERTY_UPDATED event data
    const validateEventDataCallback = (0, $cozmU.useCallback)((eventData)=>{
        const defaultValues = {
            title: appTitle,
            icon: app.properties.icon || '',
            tooltip: app.properties.tooltip || ''
        };
        return (0, $3b594b06ac9b7376$export$96933cae6933ce51)(eventData, defaultValues);
    }, [
        appTitle,
        app.properties.icon,
        app.properties.tooltip
    ]);
    const runGeneralContentPropertyQuery = (0, $cozmU.useCallback)(()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: generalContentPropertyData, refetch: refetchQueryContentProperties } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $jMyy4.useQueryInterop)($1cb9b1bda2de2c04$var$GENERAL_CONTENT_PROPERTY_QUERY, {
            variables: {
                contentId: extensionData.content?.id
            },
            __callerPackage__: "content-header"
        });
        return {
            data: generalContentPropertyData,
            refetch: refetchQueryContentProperties
        };
    }, [
        extensionData
    ]); // Run general content property query to get all properties (including IDs), if the app has a contentPropertyKey
    const queryResult = app.properties.contentPropertyKey ? runGeneralContentPropertyQuery() : null;
    const generalData = queryResult?.data || null;
    const refetchContentProperties = queryResult?.refetch; // Validate content property data and get clean values
    const validatedProperties = validateContentPropertyDataCallback(generalData);
    (0, $cozmU.useEffect)(()=>{
        // refetch for updates on popup.content close
        // Only run if app has defined contentPropertyKey
        if (contentPropertyKey && !!validatedProperties.contentPropertyKey && validatedProperties.contentPropertyKey !== '') {
            setContentPropertyKey(validatedProperties.contentPropertyKey);
            setIsLoading(false); // Update app properties with validated values
            if (validatedProperties.title && validatedProperties.title !== '') setAppTitle((0, $9fBoq.extensionTitle)(app, validatedProperties.title));
            if (validatedProperties.icon && validatedProperties.icon !== '') setAppIcon(validatedProperties.icon);
            if (validatedProperties.tooltip && validatedProperties.tooltip !== '') setAppTooltip(validatedProperties.tooltip);
        } else if (!isOpen && appHasDynamicProperties) fetchDynamicProperties();
    }, [
        isOpen,
        appHasDynamicProperties,
        fetchDynamicProperties,
        validatedProperties.title,
        validatedProperties.icon,
        validatedProperties.tooltip,
        validatedProperties.contentPropertyKey,
        setAppTitle,
        setAppIcon,
        setAppTooltip,
        setContentPropertyKey,
        contentPropertyKey,
        app
    ]); // Event listener for FORGE_CONTENT_PROPERTY_UPDATED events
    (0, $cozmU.useEffect)(()=>{
        const handleContentPropertyUpdate = async (event)=>{
            const customEvent = event;
            if (customEvent.detail?.payload?.propertyKey !== app.properties.contentPropertyKey) return;
             // Refetch content properties to get the latest data and ensure proper validation
            // This is important when multiple apps use the same contentPropertyKey
            if (refetchContentProperties) try {
                await refetchContentProperties();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn('Failed to refetch content properties on event update:', error);
            }
             // Validate the event data using the specific event validation method
            const validatedData = validateEventDataCallback(customEvent.detail?.payload); // Update app properties with validated values
            if (validatedData.title && validatedData.title !== '') setAppTitle((0, $9fBoq.extensionTitle)(app, validatedData.title));
            if (validatedData.icon && validatedData.icon !== '') setAppIcon(validatedData.icon);
            if (validatedData.tooltip && validatedData.tooltip !== '') setAppTooltip(validatedData.tooltip);
        }; // Only process if this event is for our content property key
        if (!contentPropertyKey || contentPropertyKey === '') return ()=>{}; // Return empty cleanup function to maintain React lifecycle consistency
        document.addEventListener('forge.bridge.FORGE_CONTENT_PROPERTY_UPDATED', handleContentPropertyUpdate); // Cleanup function to remove event listener
        return ()=>{
            document.removeEventListener('forge.bridge.FORGE_CONTENT_PROPERTY_UPDATED', handleContentPropertyUpdate);
        };
    }, [
        validateEventDataCallback,
        contentPropertyKey,
        setAppTitle,
        setAppIcon,
        setAppTooltip,
        app,
        refetchContentProperties
    ]);
    const appImageAlt = formatMessage($1cb9b1bda2de2c04$var$i18n.appIcon);
    const handleAppImageError = (event)=>{
        event.currentTarget.src = (0, (/*@__PURE__*/$parcel$interopDefault($46f2a733fab59ac5$exports)));
    };
    const ForgeAppButton = hasAuthoritativeBylineAppSnapshot && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        testId: "byline-forge-app-button",
        xcss: $1cb9b1bda2de2c04$var$sharedForgeAppButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5xte.BylineAppTriggerVisual), {
        isInteractive: true,
        showDot: !(isHidden || hideDot)
    }, appIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: appImageAlt,
        "data-testid": "byline-forge-app-image",
        height: 14,
        onError: handleAppImageError,
        src: appIcon,
        width: 14
    }) : null, appTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        testId: "byline-forge-app-button",
        xcss: [
            $1cb9b1bda2de2c04$var$forgeAppButtonStyles,
            !(isHidden || hideDot) && $1cb9b1bda2de2c04$var$forgeAppButtonDotStyles
        ]
    }, appIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$Image, {
        alt: appImageAlt,
        "data-testid": "byline-forge-app-image",
        onError: handleAppImageError,
        src: appIcon
    }) : null, appTitle);
    const bylineForgeAppHeaderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$ByLineForgeAppHeaderWrapper, {
        ref: defineTriggerRef && reference ? defineTriggerRef(reference) : null,
        onClick: toggleClose,
        isHidden: isHidden,
        "data-testid": "forge-byline-header-wrapper"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        testId: "byline-forge-app-trigger-loading-spinner"
    }) : ForgeAppButton);
    return app.properties?.keyboardShortcut?.accelerator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
        module: app,
        tooltip: appTooltip ?? ''
    }, bylineForgeAppHeaderWrapper) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        tag: "span",
        content: appTooltip
    }, bylineForgeAppHeaderWrapper);
};
const $1cb9b1bda2de2c04$export$d2159b9f3f077903 = (t0)=>{
    const $ = (0, $bDgLe.c)(80);
    const { app: app, contentId: contentId, isHidden: t1, setShowAll: t2, hideDot: t3, hasAuthoritativeBylineAppSnapshot: t4 } = t0;
    const isHidden = t1 === undefined ? false : t1;
    const setShowAll = t2 === undefined ? $1cb9b1bda2de2c04$var$_temp : t2;
    const hideDot = t3 === undefined ? false : t3;
    const hasAuthoritativeBylineAppSnapshot = t4 === undefined ? false : t4;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isEditing = isLivePage || isOnEditRoute;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [popupRef, setPopupRef] = (0, $cozmU.useState)(null);
    const [triggerRef, setTriggerRef] = (0, $cozmU.useState)(null);
    let t5;
    if ($[0] !== app) {
        t5 = (0, $9fBoq.extensionTitle)(app);
        $[0] = app;
        $[1] = t5;
    } else t5 = $[1];
    const [appTitle, setAppTitle] = (0, $cozmU.useState)(t5);
    const [t6] = (0, $ep3mz.usePageState)();
    const { routeName: routeName, spaceKey: spaceAlias } = t6;
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t7;
    if ($[2] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[2] = routeName;
        $[3] = t7;
    } else t7 = $[3];
    const t8 = isLivePage ? "live" : null;
    let t9;
    if ($[4] !== contentId || $[5] !== t7 || $[6] !== t8) {
        t9 = {
            id: contentId,
            type: t7,
            subtype: t8
        };
        $[4] = contentId;
        $[5] = t7;
        $[6] = t8;
        $[7] = t9;
    } else t9 = $[7];
    const t10 = spaceKey || spaceAlias;
    let t11;
    if ($[8] !== spaceId || $[9] !== t10) {
        t11 = {
            id: spaceId,
            key: t10
        };
        $[8] = spaceId;
        $[9] = t10;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== t11 || $[12] !== t9) {
        t12 = {
            type: (0, $7Ndnw.FORGE_MODULE_BYLINE),
            content: t9,
            space: t11
        };
        $[11] = t11;
        $[12] = t9;
        $[13] = t12;
    } else t12 = $[13];
    const extensionData = (0, $83fWZ.useMemoizedObj)(t12);
    let t13;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (node)=>{
            setPopupRef(node);
        };
        $[14] = t13;
    } else t13 = $[14];
    const defineContentRef = t13;
    let t14;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (ref)=>(node_0)=>{
                setTriggerRef(node_0);
                ref(node_0);
            };
        $[15] = t14;
    } else t14 = $[15];
    const defineTriggerRef = t14;
    let t15;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = ()=>{
            setIsOpen(false);
        };
        $[16] = t15;
    } else t15 = $[16];
    const onClose = t15;
    let t16;
    if ($[17] !== contentId || $[18] !== experienceTracker || $[19] !== isOpen) {
        t16 = ()=>{
            !isOpen && experienceTracker.start({
                name: $1cb9b1bda2de2c04$var$EXPERIENCE_NAME,
                id: contentId,
                timeout: 10000
            });
            setIsOpen(!isOpen);
        };
        $[17] = contentId;
        $[18] = experienceTracker;
        $[19] = isOpen;
        $[20] = t16;
    } else t16 = $[20];
    const toggleClose = t16;
    let t17;
    if ($[21] !== activationId || $[22] !== app || $[23] !== contentId || $[24] !== createAnalyticsEvent || $[25] !== experienceTracker || $[26] !== routeName || $[27] !== spaceAlias || $[28] !== spaceId) {
        t17 = ()=>{
            experienceTracker.succeed({
                name: $1cb9b1bda2de2c04$var$EXPERIENCE_NAME
            });
            const appId = (0, $8a9Dm.getAppId)(app);
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_BYLINE),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE),
                        moduleKey: (0, $8a9Dm.getModuleKey)(app),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            }).fire();
        };
        $[21] = activationId;
        $[22] = app;
        $[23] = contentId;
        $[24] = createAnalyticsEvent;
        $[25] = experienceTracker;
        $[26] = routeName;
        $[27] = spaceAlias;
        $[28] = spaceId;
        $[29] = t17;
    } else t17 = $[29];
    const onInitialRender = t17;
    let t18;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = {
            close: onClose
        };
        $[30] = t18;
    } else t18 = $[30];
    const bridge = t18;
    let t19;
    if ($[31] !== popupRef || $[32] !== triggerRef) {
        t19 = {
            onClose: onClose,
            popupRef: popupRef,
            triggerRef: triggerRef
        };
        $[31] = popupRef;
        $[32] = triggerRef;
        $[33] = t19;
    } else t19 = $[33];
    (0, $lOI2p.useInlineDialogCloseManager)(t19);
    if (!spaceKey) return null;
    let InvisibleDiv;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        InvisibleDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)($1cb9b1bda2de2c04$var$_temp2);
        $[34] = InvisibleDiv;
    } else InvisibleDiv = $[34];
    if (app.properties.viewportContainer === "modal") {
        let t20;
        if ($[35] !== app || $[36] !== appTitle || $[37] !== extensionData || $[38] !== hasAuthoritativeBylineAppSnapshot || $[39] !== hideDot || $[40] !== isHidden || $[41] !== isOpen || $[42] !== toggleClose) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$ByLineForgeAppTrigger, {
                app: app,
                appTitle: appTitle,
                setAppTitle: setAppTitle,
                isOpen: isOpen,
                toggleClose: toggleClose,
                extensionData: extensionData,
                isHidden: isHidden,
                hideDot: hideDot,
                hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot
            });
            $[35] = app;
            $[36] = appTitle;
            $[37] = extensionData;
            $[38] = hasAuthoritativeBylineAppSnapshot;
            $[39] = hideDot;
            $[40] = isHidden;
            $[41] = isOpen;
            $[42] = toggleClose;
            $[43] = t20;
        } else t20 = $[43];
        let t21;
        if ($[44] !== InvisibleDiv || $[45] !== app || $[46] !== extensionData || $[47] !== isOpen || $[48] !== onInitialRender) {
            t21 = isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.ByLineForgeApp), {
                app: app,
                extensionData: extensionData,
                onInitialRender: onInitialRender,
                onTearDown: onClose,
                bridge: bridge
            })) : null;
            $[44] = InvisibleDiv;
            $[45] = app;
            $[46] = extensionData;
            $[47] = isOpen;
            $[48] = onInitialRender;
            $[49] = t21;
        } else t21 = $[49];
        let t22;
        if ($[50] !== t20 || $[51] !== t21) {
            t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t20, t21);
            $[50] = t20;
            $[51] = t21;
            $[52] = t22;
        } else t22 = $[52];
        return t22;
    }
    const t20 = !isEditing;
    let t21;
    if ($[53] !== app || $[54] !== extensionData || $[55] !== onInitialRender || $[56] !== popupRef) {
        t21 = (t22)=>{
            const { update: scheduleUpdate } = t22;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$ContentWrapper, {
                ref: defineContentRef,
                "data-testid": "forge-popup-content-wrapper"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYZsR.ResizeChangeListener), {
                onUpdate: scheduleUpdate,
                popupRef: popupRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.ByLineForgeApp), {
                app: app,
                extensionData: extensionData,
                onInitialRender: onInitialRender,
                onTearDown: onClose,
                bridge: bridge
            })));
        };
        $[53] = app;
        $[54] = extensionData;
        $[55] = onInitialRender;
        $[56] = popupRef;
        $[57] = t21;
    } else t21 = $[57];
    let t22;
    if ($[58] !== app || $[59] !== appTitle || $[60] !== extensionData || $[61] !== hasAuthoritativeBylineAppSnapshot || $[62] !== hideDot || $[63] !== isHidden || $[64] !== isOpen || $[65] !== toggleClose) {
        t22 = (t23)=>{
            const { ref: ref_0 } = t23;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$ByLineForgeAppTrigger, {
                app: app,
                appTitle: appTitle,
                setAppTitle: setAppTitle,
                reference: ref_0,
                isOpen: isOpen,
                defineTriggerRef: defineTriggerRef,
                toggleClose: toggleClose,
                extensionData: extensionData,
                isHidden: isHidden,
                hideDot: hideDot,
                hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot
            });
        };
        $[58] = app;
        $[59] = appTitle;
        $[60] = extensionData;
        $[61] = hasAuthoritativeBylineAppSnapshot;
        $[62] = hideDot;
        $[63] = isHidden;
        $[64] = isOpen;
        $[65] = toggleClose;
        $[66] = t22;
    } else t22 = $[66];
    let t23;
    if ($[67] !== appTitle || $[68] !== isOpen || $[69] !== t20 || $[70] !== t21 || $[71] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            shouldRenderToParent: t20,
            testId: "forge-action-popup",
            role: "dialog",
            content: t21,
            label: appTitle,
            isOpen: isOpen,
            placement: "bottom-start",
            trigger: t22
        });
        $[67] = appTitle;
        $[68] = isOpen;
        $[69] = t20;
        $[70] = t21;
        $[71] = t22;
        $[72] = t23;
    } else t23 = $[72];
    let t24;
    if ($[73] !== app || $[74] !== isEditing || $[75] !== setShowAll) {
        t24 = !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
            module: app,
            action: ()=>{
                setShowAll(true);
                setIsOpen(true);
            }
        });
        $[73] = app;
        $[74] = isEditing;
        $[75] = setShowAll;
        $[76] = t24;
    } else t24 = $[76];
    let t25;
    if ($[77] !== t23 || $[78] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t23, t24);
        $[77] = t23;
        $[78] = t24;
        $[79] = t25;
    } else t25 = $[79];
    return t25;
};
function $1cb9b1bda2de2c04$var$_temp() {}
function $1cb9b1bda2de2c04$var$_temp2(t0, __cmplr) {
    const { as: t1, style: __cmpls, ...__cmplp } = t0;
    const C = t1 === undefined ? "div" : t1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbYbGa",
            __cmplp.className
        ])
    });
}















var $5SGpQ = parcelRequire("5SGpQ");


var $jmUhx = parcelRequire("jmUhx");

const $8a60fc49afcf0f5b$var$i18n = (0, $kSwu1.defineMessages)({
    showMore: {
        id: "content-header.by-line.apps-show-more",
        defaultMessage: "Show more"
    },
    showLess: {
        id: "content-header.by-line.apps.show-less",
        defaultMessage: "Show less"
    }
});
const $8a60fc49afcf0f5b$export$94132a0e348806d4 = null; // eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $8a60fc49afcf0f5b$var$ShowMoreLess = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _1UtDYzZpcK _0wOv4Q7zJH _3UcnShqogv _1Yjlt598eZ _2AckfdYbGa _42hYr56wH8 _3Ku51IbQDk _0OU75rvbI6 _1eQ8NNZpcK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
const $8a60fc49afcf0f5b$var$StyledButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $5SGpQ.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4vhRtvue9s _2yzFFQSqN7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /* eslint-enable @atlaskit/ui-styling-standard/no-important-styles */ 
const $8a60fc49afcf0f5b$export$e5bc424bebb08325 = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { showMore: t1, showButtonDesign: t2, setShowAll: setShowAll } = t0;
    const showMore = t1 === undefined ? false : t1;
    const showButtonDesign = t2 === undefined ? false : t2;
    const intl = (0, $kSwu1.useIntl)();
    const textKey = showMore ? $8a60fc49afcf0f5b$var$i18n.showMore : $8a60fc49afcf0f5b$var$i18n.showLess;
    const testIdText = showMore ? "more" : "less";
    let t3;
    if ($[0] !== setShowAll || $[1] !== showMore) {
        t3 = (event)=>{
            if (event.key === "Enter") {
                setShowAll(showMore);
                setTimeout($8a60fc49afcf0f5b$var$_temp, 0);
            }
        };
        $[0] = setShowAll;
        $[1] = showMore;
        $[2] = t3;
    } else t3 = $[2];
    const handleKeyDown = t3;
    let t4;
    if ($[3] !== handleKeyDown || $[4] !== intl || $[5] !== setShowAll || $[6] !== showButtonDesign || $[7] !== showMore || $[8] !== testIdText || $[9] !== textKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, showButtonDesign ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a60fc49afcf0f5b$var$StyledButton, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
                label: ""
            }),
            appearance: "subtle",
            testId: `live-pages-byline-show-${testIdText}`,
            onClick: ()=>setShowAll(showMore)
        }, intl.formatMessage(textKey)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a60fc49afcf0f5b$var$ShowMoreLess, {
            role: "button",
            onClick: ()=>setShowAll(showMore),
            "data-testid": `byline-show-${testIdText}`,
            tabIndex: 0,
            onKeyDown: handleKeyDown,
            id: "byline-apps-show-more-less-toggle"
        }, intl.formatMessage(textKey)));
        $[3] = handleKeyDown;
        $[4] = intl;
        $[5] = setShowAll;
        $[6] = showButtonDesign;
        $[7] = showMore;
        $[8] = testIdText;
        $[9] = textKey;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
function $8a60fc49afcf0f5b$var$_temp() {
    document.getElementById("byline-apps-show-more-less-toggle")?.focus();
}


const $cd6af931b4e9ea04$var$NUMBER_OF_VISIBLE_APPS = 3;
const $cd6af931b4e9ea04$var$LIVE_PAGES_NUMBER_OF_VISIBLE_APPS = 4; // eslint-disable-next-line @compiled/no-exported-css, @compiled/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $cd6af931b4e9ea04$export$94132a0e348806d4 = null; // eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $cd6af931b4e9ea04$var$StyledWebItemList = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $asQED.WebItemList) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2XghbEn1Zi _2qu77JdnbC _1vTVu6dnbC _1NtoLtdnbC _0HXiU0dnbC _27y5OMdnbC _2Cd6PSdnbC _1jHGkcdnbC _2oVaLednbC _0dSRFrvbI6 _29szWcvbI6 _2IjzHGZpcK _13g1dfZpcK _20I9K8qogv _2nx5EY98eZ _1JfYJOYbGa _1blFbC6wH8 _45DIsCbQDk _3Za31wvbI6 _1SZqtMZpcK _2tv9TP98eZ _0WrLWkYbGa _46xcRf6wH8 _2HYQVbKGUX _27sYQ7YXK7 _1UihsyKGUX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $cd6af931b4e9ea04$var$UFOByLineAppsComponentWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, name: name, isEmpty: isEmpty } = t0;
    if (!(0, $9wGTI.fg)("confluence_annotate_byline") || isEmpty) return children;
    let t1;
    if ($[0] !== children || $[1] !== name) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: name
        }, children);
        $[0] = children;
        $[1] = name;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $cd6af931b4e9ea04$export$127ace2288e0ed63 = ({ contentId: contentId, connectItems: connectItems, forgeItems: forgeItems, onLoad: onLoad, showLivePagesExtensionPoints: showLivePagesExtensionPoints, showLoader: showLoader, isSingleLineByline: isSingleLineByline = false, hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const numberOfVisibleApps = showLivePagesExtensionPoints ? $cd6af931b4e9ea04$var$LIVE_PAGES_NUMBER_OF_VISIBLE_APPS : $cd6af931b4e9ea04$var$NUMBER_OF_VISIBLE_APPS;
    const [isShowAll, setShowAll] = (0, $cozmU.useState)((0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).BYLINE_APPS_SHOW_ALL));
    (0, $cozmU.useEffect)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).BYLINE_APPS_SHOW_ALL, isShowAll);
    }, [
        isShowAll
    ]);
    (0, $cozmU.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'bylineApps',
                source: 'ByLineAppsComponent',
                attributes: {
                    numberOfApps: connectItems?.length + forgeItems?.length
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        connectItems?.length,
        forgeItems?.length
    ]);
    if (showLoader) // Doing this to prevent flash during live pages SSR hydration step.
    // At this point, the data has been loaded but showLoader is still true since the onLoad is asynchronously setting the showLoader
    // state to false. It will briefly render both the placeholder and the actual content at the same time.
    // Returning null here ensures we only show actual content when the loader is not showing and prevents the flash.
    return null;
    connectItems = connectItems || [];
    forgeItems = forgeItems || [];
    const renderPart = (cApps, fApps, numberOfForgeAppsToShow)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, cApps.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd6af931b4e9ea04$var$UFOByLineAppsComponentWrapper, {
            name: "byline-apps-connect-items",
            isEmpty: cApps.length === 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd6af931b4e9ea04$var$StyledWebItemList, {
            pageId: contentId,
            webItems: cApps,
            ContainerTagName: "span",
            webItemClassName: "bylineWebItem",
            hideDot: showLivePagesExtensionPoints || isSingleLineByline,
            noContainer: isSingleLineByline,
            useBadgeStyles: true,
            hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot,
            isLegacyConnectApp: (0, $9wGTI.fg)('customer-messaging-iframe-banner-enabled')
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd6af931b4e9ea04$var$UFOByLineAppsComponentWrapper, {
            name: "byline-apps-forge-items",
            isEmpty: fApps.length === 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, fApps.map((app, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1cb9b1bda2de2c04$export$d2159b9f3f077903), {
                key: app.id,
                app: app,
                contentId: contentId,
                isHidden: isShowAll ? false : idx >= numberOfForgeAppsToShow,
                setShowAll: setShowAll,
                hideDot: showLivePagesExtensionPoints || isSingleLineByline,
                hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot
            }))))); // single line byline renders all apps initially, hiding them in overflow until user clicks show more button
    // when user clicks show more, they are shown and wrapped to next line
    if (isSingleLineByline) return renderPart(connectItems, forgeItems, connectItems.length + forgeItems.length);
    if (connectItems.length + forgeItems.length <= numberOfVisibleApps) return renderPart(connectItems, forgeItems, forgeItems.length);
    else {
        // We should show the first numberOfVisibleApps apps including Connect and Forge app;
        // however, all Forge apps need to be RENDERED in order for the Forge Keyboard Shortcut listener
        // to be rendered and active. If (Connect app + Forge apps) is greater than numberOfVisibleApps,
        // then we will show the first numberOfVisibleApps Connect and Forge apps, render all the
        // Forge apps, but visually hide the Forge apps that go beyond numberOfVisibleApps.
        const numberOfConnectAppsToRender = Math.min(connectItems.length, numberOfVisibleApps);
        const numberOfForgeAppsToShow_0 = numberOfVisibleApps - numberOfConnectAppsToRender;
        const firstConnectApps = connectItems.slice(0, numberOfConnectAppsToRender);
        const remainingConnectApps = connectItems.slice(numberOfConnectAppsToRender);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, renderPart(firstConnectApps, forgeItems, numberOfForgeAppsToShow_0), isShowAll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, renderPart(remainingConnectApps, [], 0), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a60fc49afcf0f5b$export$e5bc424bebb08325), {
            showMore: false,
            showButtonDesign: !!showLivePagesExtensionPoints,
            setShowAll: setShowAll
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a60fc49afcf0f5b$export$e5bc424bebb08325), {
            showMore: true,
            showButtonDesign: !!showLivePagesExtensionPoints,
            setShowAll: setShowAll
        }));
    }
};



var $3aDMt = parcelRequire("3aDMt");

const $dc19d0558ac0af95$var$ByLineAppRuntimeHandoff = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbcK7c _2Sx1tOYbGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $dc19d0558ac0af95$var$ByLineAppRuntime = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbcK7c",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $dc19d0558ac0af95$var$ByLineAppSnapshotFallback = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbcK7c",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $dc19d0558ac0af95$export$da423a9f3d95b9b8 = (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { contentId: contentId, connectItems: connectItems, forgeItems: forgeItems, forgeError: forgeError, isSingleLineByline: isSingleLineByline, onBylineAppsLoaded: onBylineAppsLoaded, showLivePagesExtensionPoints: showLivePagesExtensionPoints, loadingConnectItems: t1, loadingForgeItems: t2, noContainer: t3, authoritativeSnapshot: authoritativeSnapshot } = t0;
    const loadingConnectItems = t1 === undefined ? false : t1;
    const loadingForgeItems = t2 === undefined ? false : t2;
    const noContainer = t3 === undefined ? false : t3;
    const isLoading = loadingConnectItems || loadingForgeItems;
    let t4;
    if ($[0] !== authoritativeSnapshot || $[1] !== isLoading) {
        t4 = isLoading && !(0, $6mKj3.expValEquals)("confluence_skip_byline_apps_placeholder", "isEnabled", true) && !(authoritativeSnapshot && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true));
        $[0] = authoritativeSnapshot;
        $[1] = isLoading;
        $[2] = t4;
    } else t4 = $[2];
    const [showLoader, setShowLoader] = (0, $cozmU.useState)(t4);
    let t5;
    if ($[3] !== onBylineAppsLoaded) {
        t5 = ()=>{
            setShowLoader(false);
            onBylineAppsLoaded?.();
        };
        $[3] = onBylineAppsLoaded;
        $[4] = t5;
    } else t5 = $[4];
    const handleLoad = t5;
    const shouldRenderBylineApps = (0, $6mKj3.expValEquals)("confluence_skip_byline_apps_placeholder", "isEnabled", true) ? !isLoading : true;
    let t6;
    if ($[5] !== authoritativeSnapshot || $[6] !== connectItems || $[7] !== contentId || $[8] !== forgeError || $[9] !== forgeItems || $[10] !== handleLoad || $[11] !== isSingleLineByline || $[12] !== showLivePagesExtensionPoints || $[13] !== showLoader) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80koo.RequireLegacyWRM), {
            key: "byline-app-wrm",
            wrm: "wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-content-byline-resources-v5"
        }, ()=>{
            if (forgeError && (!authoritativeSnapshot || !(0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true))) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(forgeError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: forgeError
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                    name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
                });
            }
            const unhandledForgeError = forgeError && !(0, $7Sm4c.isErrorMarkedAsHandled)(forgeError) ? forgeError : undefined;
            const apps = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, unhandledForgeError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: unhandledForgeError
            }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cd6af931b4e9ea04$export$127ace2288e0ed63), {
                key: contentId,
                contentId: contentId,
                forgeItems: forgeError ? [] : forgeItems,
                connectItems: connectItems,
                showLivePagesExtensionPoints: showLivePagesExtensionPoints,
                onLoad: handleLoad,
                showLoader: showLoader,
                isSingleLineByline: isSingleLineByline,
                hasAuthoritativeBylineAppSnapshot: Boolean(authoritativeSnapshot)
            }), unhandledForgeError ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
            }));
            return authoritativeSnapshot && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc19d0558ac0af95$var$ByLineAppRuntime, {
                "data-byline-app-runtime": true
            }, apps) : apps;
        });
        $[5] = authoritativeSnapshot;
        $[6] = connectItems;
        $[7] = contentId;
        $[8] = forgeError;
        $[9] = forgeItems;
        $[10] = handleLoad;
        $[11] = isSingleLineByline;
        $[12] = showLivePagesExtensionPoints;
        $[13] = showLoader;
        $[14] = t6;
    } else t6 = $[14];
    const runtimeApps = t6;
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
        });
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== connectItems || $[17] !== forgeItems || $[18] !== noContainer || $[19] !== showLoader) {
        t8 = showLoader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ea8d19a294b60fd$export$1196cbdc07fcbaba), {
            connectItems: connectItems,
            forgeItems: forgeItems,
            noContainer: noContainer
        });
        $[16] = connectItems;
        $[17] = forgeItems;
        $[18] = noContainer;
        $[19] = showLoader;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== authoritativeSnapshot || $[22] !== runtimeApps || $[23] !== shouldRenderBylineApps) {
        t9 = shouldRenderBylineApps && (authoritativeSnapshot && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc19d0558ac0af95$var$ByLineAppRuntimeHandoff, null, runtimeApps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc19d0558ac0af95$var$ByLineAppSnapshotFallback, {
            "data-byline-app-snapshot": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aDMt.AuthoritativeByLineApps), {
            snapshot: authoritativeSnapshot
        }))) : runtimeApps);
        $[21] = authoritativeSnapshot;
        $[22] = runtimeApps;
        $[23] = shouldRenderBylineApps;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== t8 || $[26] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t7, t8, t9);
        $[25] = t8;
        $[26] = t9;
        $[27] = t10;
    } else t10 = $[27];
    return t10;
};

const $dc19d0558ac0af95$export$573ad1d5e82d9d7e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9W4UB",
    name: "LazyLivePagesByLineApps",
    loader: async ()=>{
        return (await Promise.resolve(module.exports)).LivePagesByLineApps;
    },
    loading: (props)=>props.authoritativeSnapshot && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aDMt.AuthoritativeByLineApps), {
            snapshot: props.authoritativeSnapshot
        }) : (0, $6mKj3.expValEquals)('confluence_skip_byline_apps_placeholder', 'isEnabled', true) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ea8d19a294b60fd$export$1196cbdc07fcbaba), props)
});
module.exports["LivePagesByLineApps"] = $dc19d0558ac0af95$export$da423a9f3d95b9b8;
module.exports["LazyLivePagesByLineApps"] = $dc19d0558ac0af95$export$573ad1d5e82d9d7e;

});

parcelRegister("83fWZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

const $7a82ae306aa8d2fb$export$656295fdbe704c1d = (obj)=>{
    const ref = (0, $cozmU.useRef)(obj);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(ref.current, obj)) ref.current = obj;
    return ref.current;
};
const $7a82ae306aa8d2fb$export$3b131fc84567c0ad = (data)=>{
    if (!data) return false;
    if ('singleContent' in data) return false;
    if ('content' in data) {
        const properties = data?.content?.nodes?.[0]?.properties?.nodes || [];
        const editorVersion = properties.find((p)=>p?.key === 'editor');
        return editorVersion?.value?.includes('v2') || false;
    }
    return false;
};
const $7a82ae306aa8d2fb$export$44be1e207a638653 = (graphqlUser)=>({
        isAnonymous: !graphqlUser?.accountId,
        userId: graphqlUser?.accountId ?? undefined,
        fullName: graphqlUser?.displayName,
        avatarUrl: graphqlUser?.profilePicture?.path
    });
module.exports["useMemoizedObj"] = $7a82ae306aa8d2fb$export$656295fdbe704c1d;
module.exports["isFabricEditor"] = $7a82ae306aa8d2fb$export$3b131fc84567c0ad;
module.exports["toUserProps"] = $7a82ae306aa8d2fb$export$44be1e207a638653;

});

parcelRegister("5YSiR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5cc6a47526452ac3$export$a07022482001031b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R7O8o",
    name: "LazyAIPlannerSyncByline",
    loader: async ()=>(await (parcelRequire("fYQNw"))).AIPlannerSyncByline,
    loading: ()=>null
});
module.exports["LazyAIPlannerSyncByline"] = $5cc6a47526452ac3$export$a07022482001031b;

});

parcelRegister("fYQNw", function(module, exports) {

let $ba256a1ff0492c92$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ba256a1ff0492c92$var$load("5He1y"),
    $ba256a1ff0492c92$var$load("aLwQm"),
    $ba256a1ff0492c92$var$load("k8GKJ"),
    $ba256a1ff0492c92$var$load("6zCMk"),
    $ba256a1ff0492c92$var$load("3w65n")
]).then(()=>parcelRequire('9gzhk'));

});

parcelRegister("3TrzI", function(module, exports) {
const $b443a1044784ca20$export$847f5bb75f781390 = 'AI_PLANNER';
const $b443a1044784ca20$export$593a849e6e9b7c73 = 'artifact.resolveByConfluenceContentAri';
module.exports["AI_PLANNER_GENERATED_BY"] = $b443a1044784ca20$export$847f5bb75f781390;
module.exports["AI_PLANNER_SYNC_BYLINE_RESOLVER_PROCEDURE"] = $b443a1044784ca20$export$593a849e6e9b7c73;

});

parcelRegister("dGhsu", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<fe682ef6a4763a908e042ab6180c14cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95f197b43e539c4a$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "useNewContentTopper",
            "variableName": "useNewContentTopper"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "useNewContentTopper"
            }
        ],
        "kind": "Fragment",
        "name": "ContentTitleWithByLine_content",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "ContentTitle_content"
            },
            {
                "args": v0 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "ByLine_content"
            },
            {
                "kind": "FragmentSpread",
                "name": "ArchivedPageBannerV2Status_content"
            },
            {
                "kind": "FragmentSpread",
                "name": "MeetingNotesAutomationDiscoveryFragment_content"
            }
        ],
        "type": "Content"
    };
}();
$95f197b43e539c4a$var$node.hash = "ca20373b83130249db590217deb6d277";
var $95f197b43e539c4a$export$2e2bcd8739ae039 = $95f197b43e539c4a$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");




var $9XdgS = parcelRequire("9XdgS");




var $kQRQB = parcelRequire("kQRQB");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $4PPzL = parcelRequire("4PPzL");


var $3IBnw = parcelRequire("3IBnw");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $gjEAi = parcelRequire("gjEAi");


var $kygIi = parcelRequire("kygIi");


var $8zMP3 = parcelRequire("8zMP3");


var $bQm3c = parcelRequire("bQm3c");


var $1xpoY = parcelRequire("1xpoY");


var $35oAA = parcelRequire("35oAA");

const $aaeb66d37f355457$export$a5ae28e9da358c58 = (0, $95f197b43e539c4a$export$2e2bcd8739ae039);
const $aaeb66d37f355457$var$ByLineWithClassificationFragment = (0, $9XdgS.ByLine);
const $aaeb66d37f355457$var$ByLineFromFragmentWithClassificationFragment = (0, $9XdgS.ByLineFromFragment);
const $aaeb66d37f355457$var$BylineCenterStyles = (0, $buxP3.xcss)({
    justifyContent: 'center'
});
const $aaeb66d37f355457$var$ApprovalBannerStyles = (0, $buxP3.xcss)({
    marginBlockEnd: 'space.200'
});
const $aaeb66d37f355457$var$styles = {
    titleAreaBannerWrapper: "_0rIjyk5zaO"
};
const $aaeb66d37f355457$var$TitleAreaBannerWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $aaeb66d37f355457$var$styles.titleAreaBannerWrapper
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $aaeb66d37f355457$export$6ac99e13b8ebf390 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "byline-apps"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ContentTitleWithByLineInner, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $aaeb66d37f355457$var$ContentTitleWithByLineInner = (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    let analyticsBylineFragmentRef;
    let byLineContributors;
    let bylineClassificationFragmentRef;
    let contentClassificationFragmentRef;
    let contentFragmentRef;
    let props;
    let reactionsContentFragmentRef;
    let titleSpaceFragmentRef;
    if ($[0] !== t0) {
        ({ contentFragmentRef: contentFragmentRef, byLineContributors: byLineContributors, titleSpaceFragmentRef: titleSpaceFragmentRef, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsBylineFragmentRef;
        $[2] = byLineContributors;
        $[3] = bylineClassificationFragmentRef;
        $[4] = contentClassificationFragmentRef;
        $[5] = contentFragmentRef;
        $[6] = props;
        $[7] = reactionsContentFragmentRef;
        $[8] = titleSpaceFragmentRef;
    } else {
        analyticsBylineFragmentRef = $[1];
        byLineContributors = $[2];
        bylineClassificationFragmentRef = $[3];
        contentClassificationFragmentRef = $[4];
        contentFragmentRef = $[5];
        props = $[6];
        reactionsContentFragmentRef = $[7];
        titleSpaceFragmentRef = $[8];
    }
    if (contentFragmentRef && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_title_byline_frag_dedup") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
        let t1;
        if ($[9] !== analyticsBylineFragmentRef || $[10] !== byLineContributors || $[11] !== bylineClassificationFragmentRef || $[12] !== contentClassificationFragmentRef || $[13] !== contentFragmentRef || $[14] !== props || $[15] !== reactionsContentFragmentRef || $[16] !== titleSpaceFragmentRef) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ContentTitleWithByLineFragmentReader, {
                ...props,
                contentFragmentRef: contentFragmentRef,
                byLineContributors: byLineContributors,
                titleSpaceFragmentRef: titleSpaceFragmentRef,
                bylineClassificationFragmentRef: bylineClassificationFragmentRef,
                contentClassificationFragmentRef: contentClassificationFragmentRef,
                reactionsContentFragmentRef: reactionsContentFragmentRef,
                analyticsBylineFragmentRef: analyticsBylineFragmentRef
            });
            $[9] = analyticsBylineFragmentRef;
            $[10] = byLineContributors;
            $[11] = bylineClassificationFragmentRef;
            $[12] = contentClassificationFragmentRef;
            $[13] = contentFragmentRef;
            $[14] = props;
            $[15] = reactionsContentFragmentRef;
            $[16] = titleSpaceFragmentRef;
            $[17] = t1;
        } else t1 = $[17];
        return t1;
    }
    let t1;
    if ($[18] !== analyticsBylineFragmentRef || $[19] !== bylineClassificationFragmentRef || $[20] !== contentClassificationFragmentRef || $[21] !== props || $[22] !== reactionsContentFragmentRef) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ContentTitleWithByLineQuery, {
            ...props,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef
        });
        $[18] = analyticsBylineFragmentRef;
        $[19] = bylineClassificationFragmentRef;
        $[20] = contentClassificationFragmentRef;
        $[21] = props;
        $[22] = reactionsContentFragmentRef;
        $[23] = t1;
    } else t1 = $[23];
    return t1;
};
const $aaeb66d37f355457$var$ContentTitleWithByLineQuery = (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { contentId: contentId, spaceKey: spaceKey, banner: banner, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, headingContainer: headingContainer, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, contentSubType: contentSubType, spaceId: spaceId, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, meetingNotesAutomationDiscoveryFragmentRef: meetingNotesAutomationDiscoveryFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, hasByLine: t1 } = t0;
    const hasByLine = t1 === undefined ? true : t1;
    const { versionOverride: versionOverride, embeddedContentRender: embeddedContentRender } = (0, $35oAA.useViewPageParams)();
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[0] !== contentType || $[1] !== isEmbeddedPage || $[2] !== isRovoLLMEnabled) {
        t2 = isRovoLLMEnabled && contentType === "page" && !isEmbeddedPage && (0, $9wGTI.fg)("cc_automations_discovery_nudges");
        $[0] = contentType;
        $[1] = isEmbeddedPage;
        $[2] = isRovoLLMEnabled;
        $[3] = t2;
    } else t2 = $[3];
    const shouldRenderMeetingNotesAutomationDiscovery = t2;
    let t3;
    if ($[4] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[4] = contentId;
        $[5] = t3;
    } else t3 = $[5];
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)(t3);
    const isBylineCenterStyles = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const t4 = isBylineCenterStyles && $aaeb66d37f355457$var$BylineCenterStyles;
    let t5;
    if ($[6] !== t4) {
        t5 = [
            t4
        ];
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const t6 = isBylineCenterStyles ? "centered-content-title-and-byline" : "content-title-and-byline";
    let t7;
    if ($[8] !== analyticsBylineFragmentRef || $[9] !== bylineClassificationFragmentRef || $[10] !== contentClassificationFragmentRef || $[11] !== contentId || $[12] !== contentSubType || $[13] !== contentType || $[14] !== embeddedContentRender || $[15] !== hasByLine || $[16] !== hasByLineContributors || $[17] !== hasByLineExtensions || $[18] !== meetingNotesAutomationDiscoveryFragmentRef || $[19] !== reactionsContentFragmentRef || $[20] !== shouldRenderMeetingNotesAutomationDiscovery || $[21] !== shouldShowBylineReactions || $[22] !== spaceId || $[23] !== versionOverride) {
        t7 = hasByLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ByLineWithClassificationFragment, {
            contentId: contentId,
            versionOverride: versionOverride,
            embeddedContentRender: embeddedContentRender,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentType: contentType,
            contentSubType: contentSubType,
            spaceId: spaceId,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef
        }), (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $aaeb66d37f355457$var$ApprovalBannerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gjEAi.ApprovalBanner), null))), shouldRenderMeetingNotesAutomationDiscovery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kygIi.LazyMeetingNotesAutomationDiscoveryFragment), {
            contentFragmentRef: meetingNotesAutomationDiscoveryFragmentRef,
            postOfficePlacementId: "confluence-view-page-title-area-banner",
            WrapperComponent: $aaeb66d37f355457$var$TitleAreaBannerWrapper
        }));
        $[8] = analyticsBylineFragmentRef;
        $[9] = bylineClassificationFragmentRef;
        $[10] = contentClassificationFragmentRef;
        $[11] = contentId;
        $[12] = contentSubType;
        $[13] = contentType;
        $[14] = embeddedContentRender;
        $[15] = hasByLine;
        $[16] = hasByLineContributors;
        $[17] = hasByLineExtensions;
        $[18] = meetingNotesAutomationDiscoveryFragmentRef;
        $[19] = reactionsContentFragmentRef;
        $[20] = shouldRenderMeetingNotesAutomationDiscovery;
        $[21] = shouldShowBylineReactions;
        $[22] = spaceId;
        $[23] = versionOverride;
        $[24] = t7;
    } else t7 = $[24];
    let t8;
    if ($[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t5,
            testId: t6
        }, t7);
        $[25] = t5;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    let t9;
    if ($[29] !== banner || $[30] !== contentId || $[31] !== hasCoverPicture || $[32] !== headingContainer || $[33] !== isEmbeddedPage || $[34] !== pageWidthType || $[35] !== spaceKey || $[36] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kQRQB.ContentTitle), {
            banner: banner,
            contentId: contentId,
            spaceKey: spaceKey,
            headingContainer: headingContainer,
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage
        }, t8);
        $[29] = banner;
        $[30] = contentId;
        $[31] = hasCoverPicture;
        $[32] = headingContainer;
        $[33] = isEmbeddedPage;
        $[34] = pageWidthType;
        $[35] = spaceKey;
        $[36] = t8;
        $[37] = t9;
    } else t9 = $[37];
    return t9;
};
const $aaeb66d37f355457$var$ContentTitleWithByLineFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { contentFragmentRef: contentFragmentRef, byLineContributors: byLineContributors, titleSpaceFragmentRef: titleSpaceFragmentRef, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, contentId: contentId, spaceKey: spaceKey, banner: banner, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, headingContainer: headingContainer, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, contentSubType: contentSubType, spaceId: spaceId, hasByLine: t1 } = t0;
    const hasByLine = t1 === undefined ? true : t1;
    const content = (0, $6SsN4.useFragment)($aaeb66d37f355457$export$a5ae28e9da358c58, contentFragmentRef);
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[0] !== contentType || $[1] !== isEmbeddedPage || $[2] !== isRovoLLMEnabled) {
        t2 = isRovoLLMEnabled && contentType === "page" && !isEmbeddedPage && (0, $9wGTI.fg)("cc_automations_discovery_nudges");
        $[0] = contentType;
        $[1] = isEmbeddedPage;
        $[2] = isRovoLLMEnabled;
        $[3] = t2;
    } else t2 = $[3];
    const shouldRenderMeetingNotesAutomationDiscovery = t2;
    let t3;
    if ($[4] !== content) {
        t3 = (0, $zalpJ.getTitleContentProperty)({
            content: {
                nodes: [
                    content
                ]
            }
        });
        $[4] = content;
        $[5] = t3;
    } else t3 = $[5];
    const { titleContentProperties: titleContentProperties } = t3;
    let t4;
    if ($[6] !== banner || $[7] !== content) {
        t4 = /*#__PURE__*/ (0, $cozmU.isValidElement)(banner) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(banner, {
            contentFragmentRef: content
        }) : banner;
        $[6] = banner;
        $[7] = content;
        $[8] = t4;
    } else t4 = $[8];
    const bannerWithContentFragmentRef = t4;
    const isBylineCenterStyles = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const t5 = isBylineCenterStyles && $aaeb66d37f355457$var$BylineCenterStyles;
    let t6;
    if ($[9] !== t5) {
        t6 = [
            t5
        ];
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const t7 = isBylineCenterStyles ? "centered-content-title-and-byline" : "content-title-and-byline";
    let t8;
    if ($[11] !== analyticsBylineFragmentRef || $[12] !== byLineContributors || $[13] !== bylineClassificationFragmentRef || $[14] !== content || $[15] !== contentClassificationFragmentRef || $[16] !== contentId || $[17] !== contentSubType || $[18] !== contentType || $[19] !== hasByLine || $[20] !== hasByLineContributors || $[21] !== hasByLineExtensions || $[22] !== reactionsContentFragmentRef || $[23] !== shouldRenderMeetingNotesAutomationDiscovery || $[24] !== shouldShowBylineReactions || $[25] !== spaceId) {
        t8 = hasByLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ByLineFromFragmentWithClassificationFragment, {
            contentId: contentId,
            contentFragmentRef: content,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentContributors: byLineContributors,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentType: contentType,
            contentSubType: contentSubType,
            spaceId: spaceId
        }), (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $aaeb66d37f355457$var$ApprovalBannerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gjEAi.ApprovalBanner), null))), shouldRenderMeetingNotesAutomationDiscovery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kygIi.LazyMeetingNotesAutomationDiscoveryFragment), {
            contentFragmentRef: content,
            postOfficePlacementId: "confluence-view-page-title-area-banner",
            WrapperComponent: $aaeb66d37f355457$var$TitleAreaBannerWrapper
        }));
        $[11] = analyticsBylineFragmentRef;
        $[12] = byLineContributors;
        $[13] = bylineClassificationFragmentRef;
        $[14] = content;
        $[15] = contentClassificationFragmentRef;
        $[16] = contentId;
        $[17] = contentSubType;
        $[18] = contentType;
        $[19] = hasByLine;
        $[20] = hasByLineContributors;
        $[21] = hasByLineExtensions;
        $[22] = reactionsContentFragmentRef;
        $[23] = shouldRenderMeetingNotesAutomationDiscovery;
        $[24] = shouldShowBylineReactions;
        $[25] = spaceId;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t6,
            testId: t7
        }, t8);
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== bannerWithContentFragmentRef || $[32] !== content || $[33] !== contentId || $[34] !== hasCoverPicture || $[35] !== headingContainer || $[36] !== isEmbeddedPage || $[37] !== pageWidthType || $[38] !== spaceKey || $[39] !== t9 || $[40] !== titleSpaceFragmentRef) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kQRQB.ContentTitleFromFragment), {
            banner: bannerWithContentFragmentRef,
            contentId: contentId,
            spaceKey: spaceKey,
            headingContainer: headingContainer,
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage,
            contentFragmentRef: content,
            spaceFragmentRef: titleSpaceFragmentRef
        }, t9);
        $[31] = bannerWithContentFragmentRef;
        $[32] = content;
        $[33] = contentId;
        $[34] = hasCoverPicture;
        $[35] = headingContainer;
        $[36] = isEmbeddedPage;
        $[37] = pageWidthType;
        $[38] = spaceKey;
        $[39] = t9;
        $[40] = titleSpaceFragmentRef;
        $[41] = t10;
    } else t10 = $[41];
    return t10;
};
module.exports["ContentTitleWithByLine"] = $aaeb66d37f355457$export$6ac99e13b8ebf390;

});

parcelRegister("9IvbC", function(module, exports) {

let $71306a162b99b673$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $71306a162b99b673$var$load("22DNY").then(()=>parcelRequire('6VDyY'));

});

parcelRegister("8r8Jg", function(module, exports) {

let $62479dc84311e839$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $62479dc84311e839$var$load("i7f39"),
    $62479dc84311e839$var$load("hwJJ4"),
    $62479dc84311e839$var$load("2BqMU"),
    $62479dc84311e839$var$load("arqPY"),
    $62479dc84311e839$var$load("lkxmG"),
    $62479dc84311e839$var$load("fq1gG"),
    $62479dc84311e839$var$load("dZsGY"),
    $62479dc84311e839$var$load("6wr18"),
    $62479dc84311e839$var$load("59hV4"),
    $62479dc84311e839$var$load("eRbl4"),
    $62479dc84311e839$var$load("hsKul"),
    $62479dc84311e839$var$load("4x9Jx"),
    $62479dc84311e839$var$load("ipIDQ"),
    $62479dc84311e839$var$load("ea3NB"),
    $62479dc84311e839$var$load("fuOfV"),
    $62479dc84311e839$var$load("jL1Ke"),
    $62479dc84311e839$var$load("5MQ0D"),
    $62479dc84311e839$var$load("ffEVr"),
    $62479dc84311e839$var$load("h4Nf7"),
    $62479dc84311e839$var$load("Wowvf"),
    $62479dc84311e839$var$load("ayJxT"),
    $62479dc84311e839$var$load("hhss7"),
    $62479dc84311e839$var$load("eShF9"),
    $62479dc84311e839$var$load("7EorR"),
    $62479dc84311e839$var$load("1C6qR")
]).then(()=>parcelRequire('kTkGJ'));

});

parcelRegister("e2zD6", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $7Qvc2 = parcelRequire("7Qvc2");

const $05a5c042457d6268$var$CREATED_BY_AI_LABEL = 'Created with Rovo';
const $05a5c042457d6268$var$EDITED_BY_AI_LABEL = 'Edited with Rovo';
const $05a5c042457d6268$var$READ_BY_AI_LABEL = 'Viewed by Rovo';
const $05a5c042457d6268$var$SOURCE_LABEL = 'Source';
const $05a5c042457d6268$var$EVIDENCE_LABEL = 'Evidence';
const $05a5c042457d6268$var$PERSISTENCE_LABEL = 'Persistence';
const $05a5c042457d6268$var$NETWORK_CALLS_LABEL = 'Network calls';
const $05a5c042457d6268$var$CREATOR_LABEL = 'Creator';
const $05a5c042457d6268$var$VERSION_LABEL = 'Version';
const $05a5c042457d6268$var$UNKNOWN_CREATOR_NAME = 'the page creator';
const $05a5c042457d6268$var$REAL_DATA_SOURCE_VALUE = 'Page content property (generatedBy)';
const $05a5c042457d6268$var$REAL_DATA_NONE_VALUE = 'None (read from existing page data)';
const $05a5c042457d6268$var$SPARK_RECEIPT_SCENARIOS = {
    CREATED_BY_AI: {
        id: 'CREATED_BY_AI',
        label: $05a5c042457d6268$var$CREATED_BY_AI_LABEL,
        description: 'Spark preview data indicates Rovo created this page.'
    },
    EDITED_BY_AI: {
        id: 'EDITED_BY_AI',
        label: $05a5c042457d6268$var$EDITED_BY_AI_LABEL,
        description: 'Spark preview data indicates Rovo helped edit this page.'
    },
    READ_BY_AI: {
        id: 'READ_BY_AI',
        label: $05a5c042457d6268$var$READ_BY_AI_LABEL,
        description: 'Spark preview data indicates Rovo read this page as context.'
    }
};
const $05a5c042457d6268$var$ROVO_AGENT_ACTOR = {
    id: 'rovo-agent-spark-preview',
    name: 'Rovo agent',
    type: 'agent',
    agentType: 'rovo',
    iconKey: 'rovo-agent'
};
const $05a5c042457d6268$var$SPACE_ORGANIZER_ACTOR = {
    id: 'space-organizer-agent-spark-preview',
    name: 'Space Organizer Agent',
    type: 'agent',
    agentType: 'space-organizer',
    iconKey: 'space-organizer-agent'
};
const $05a5c042457d6268$var$DEV_DOCS_ACTOR = {
    id: 'dev-docs-agent-spark-preview',
    name: 'Dev Docs Agent',
    type: 'agent',
    agentType: 'dev-docs',
    iconKey: 'dev-docs-agent'
};
const $05a5c042457d6268$var$FABRICATED_BUCKETS = [
    {
        scenarioId: 'EDITED_BY_AI',
        actor: $05a5c042457d6268$var$SPACE_ORGANIZER_ACTOR
    },
    {
        scenarioId: 'READ_BY_AI',
        actor: $05a5c042457d6268$var$DEV_DOCS_ACTOR
    }
];
const $05a5c042457d6268$var$isValidContentId = (contentId)=>/^[1-9]\d*$/.test(contentId);
const $05a5c042457d6268$var$resolveFabricatedBucket = (contentId)=>{
    const lastDigit = Number(contentId.charAt(contentId.length - 1));
    return lastDigit % $05a5c042457d6268$var$FABRICATED_BUCKETS.length;
};
const $05a5c042457d6268$var$createSparkPreviewSignals = (scenario)=>[
        {
            id: 'source',
            label: $05a5c042457d6268$var$SOURCE_LABEL,
            value: 'Spark preview fixture'
        },
        {
            id: 'evidence',
            label: $05a5c042457d6268$var$EVIDENCE_LABEL,
            value: `Example evidence for ${scenario.label.toLowerCase()}`
        },
        {
            id: 'persistence',
            label: $05a5c042457d6268$var$PERSISTENCE_LABEL,
            value: 'None'
        },
        {
            id: 'network',
            label: $05a5c042457d6268$var$NETWORK_CALLS_LABEL,
            value: 'None'
        }
    ];
const $05a5c042457d6268$var$createSparkPreviewEvents = (actor, scenario)=>[
        {
            id: 'context-reviewed',
            occurredAt: '2026-06-03T21:00:00.000Z',
            title: 'Context reviewed',
            description: `${actor.name} inspected example page context for ${scenario.label.toLowerCase()}.`
        },
        {
            id: 'agent-action',
            occurredAt: '2026-06-03T21:02:00.000Z',
            title: scenario.label,
            description: `${actor.name} performed the Spark preview activity recorded in this receipt.`
        },
        {
            id: 'receipt-created',
            occurredAt: '2026-06-03T21:04:00.000Z',
            title: 'Receipt prepared',
            description: 'Example evidence was collected for review in this Spark preview receipt.'
        }
    ].sort((a, b)=>a.occurredAt.localeCompare(b.occurredAt));
// Builds a CREATED_BY_AI receipt backed by REAL page data (creator, created/updated timestamps,
// version number) for pages confirmed to be created by Rovo Smart Create. Events with a missing
// timestamp are omitted so the panel never renders an Invalid Date.
const $05a5c042457d6268$var$createRealCreatedByAiReceipt = (contentId, pageData)=>{
    const scenario = $05a5c042457d6268$var$SPARK_RECEIPT_SCENARIOS.CREATED_BY_AI;
    const creatorName = pageData.creatorName?.trim() || $05a5c042457d6268$var$UNKNOWN_CREATOR_NAME;
    const versionDetail = typeof pageData.versionNumber === 'number' ? `${$05a5c042457d6268$var$VERSION_LABEL} ${pageData.versionNumber}` : null;
    const events = [];
    if (pageData.createdAt) events.push({
        id: 'page-created',
        occurredAt: pageData.createdAt,
        title: scenario.label,
        description: `${creatorName} created this page with Rovo.`
    });
    if (pageData.lastUpdatedAt) events.push({
        id: 'page-last-updated',
        occurredAt: pageData.lastUpdatedAt,
        title: 'Last updated',
        description: versionDetail ? `Latest published change (${versionDetail.toLowerCase()}).` : 'Latest published change.'
    });
    events.sort((a, b)=>a.occurredAt.localeCompare(b.occurredAt));
    const signals = [
        {
            id: 'source',
            label: $05a5c042457d6268$var$SOURCE_LABEL,
            value: $05a5c042457d6268$var$REAL_DATA_SOURCE_VALUE
        },
        {
            id: 'creator',
            label: $05a5c042457d6268$var$CREATOR_LABEL,
            value: creatorName
        },
        {
            id: 'version',
            label: $05a5c042457d6268$var$VERSION_LABEL,
            value: versionDetail ?? 'Unknown'
        },
        {
            id: 'persistence',
            label: $05a5c042457d6268$var$PERSISTENCE_LABEL,
            value: $05a5c042457d6268$var$REAL_DATA_NONE_VALUE
        },
        {
            id: 'network',
            label: $05a5c042457d6268$var$NETWORK_CALLS_LABEL,
            value: $05a5c042457d6268$var$REAL_DATA_NONE_VALUE
        }
    ];
    return {
        contentId: contentId,
        actor: $05a5c042457d6268$var$ROVO_AGENT_ACTOR,
        scenario: scenario,
        // CREATED_BY_AI receipts are sourced from real page data, so they must NOT claim "no audit log
        // was created" — that copy only applies to fabricated Spark preview receipts.
        summary: `Created with Rovo by ${creatorName}. This receipt is sourced from existing page data.`,
        events: events,
        signals: signals
    };
};
const $05a5c042457d6268$export$a31b6deb77eb892e = (contentId, pageData)=>{
    if (!(0, $9wGTI.fg)('cc_sparks_agent_trust_receipt')) return null;
    const normalizedContentId = contentId.trim();
    if (!$05a5c042457d6268$var$isValidContentId(normalizedContentId)) return null;
    // Real CREATED_BY_AI data only when the page is positively confirmed as Rovo Smart Create.
    // Exact-literal match excludes null, ONBOARDING, and AI_PLANNER.
    if (pageData?.generatedBy === (0, $7Qvc2.ROVO_SMART_CREATION_GENERATED_BY)) return $05a5c042457d6268$var$createRealCreatedByAiReceipt(normalizedContentId, pageData);
    // Non-Rovo pages fall back to fabricated EDITED_BY_AI / READ_BY_AI demo receipts only — never
    // CREATED_BY_AI, so "Created with Rovo" is never asserted on a page Rovo did not create.
    const { scenarioId: scenarioId, actor: actor } = $05a5c042457d6268$var$FABRICATED_BUCKETS[$05a5c042457d6268$var$resolveFabricatedBucket(normalizedContentId)];
    const scenario = $05a5c042457d6268$var$SPARK_RECEIPT_SCENARIOS[scenarioId];
    return {
        contentId: normalizedContentId,
        actor: actor,
        scenario: scenario,
        summary: `${scenario.description} This receipt identifies ${actor.name}, the recorded agent activity, and the chronological events available for review. Spark preview data only, not a durable audit log.`,
        events: $05a5c042457d6268$var$createSparkPreviewEvents(actor, scenario),
        signals: $05a5c042457d6268$var$createSparkPreviewSignals(scenario)
    };
};
module.exports["resolveAgentTrustReceipt"] = $05a5c042457d6268$export$a31b6deb77eb892e;

});

parcelRegister("f0mzK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kTb7m = parcelRequire("kTb7m");

const $3dd61ef4b34e980c$export$1516ba114d4009a6 = (index, appearance = 'placeholder')=>({
        key: `placeholder-link-${index}`,
        label: '',
        icon: {
            kind: 'element',
            key: `placeholder-link-${index}`,
            label: '',
            node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: "",
                color: appearance === 'placeholder' ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)",
                testId: "byline-connections-ssr-placeholder-icon"
            })
        }
    });
module.exports["createPlaceholderConnectionIcon"] = $3dd61ef4b34e980c$export$1516ba114d4009a6;

});

parcelRegister("3aDMt", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $e5xte = parcelRequire("e5xte");


var $87We3 = parcelRequire("87We3");

const $73425511e70f8b25$export$85c37fe80d19fd66 = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { snapshot: snapshot } = t0;
    if (!(0, $87We3.isByLineAppSnapshotAuthoritative)(snapshot)) return null;
    let t1;
    if ($[0] !== snapshot.apps) {
        t1 = snapshot.apps.map($73425511e70f8b25$var$_temp);
        $[0] = snapshot.apps;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
function $73425511e70f8b25$var$_temp(t0) {
    const { id: id, presentation: presentation, producer: producer } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5xte.BylineAppTriggerVisual), {
        "data-byline-app-producer": producer,
        "data-testid": producer === "connect" ? "web-item-link" : "forge-byline-header-wrapper",
        key: id,
        title: presentation.tooltip
    }, presentation.icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: "",
        height: presentation.icon.height,
        src: presentation.icon.src,
        width: presentation.icon.width
    }) : null, producer === "connect" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: presentation.label
        }
    }) : presentation.label);
}
module.exports["AuthoritativeByLineApps"] = $73425511e70f8b25$export$85c37fe80d19fd66;

});

parcelRegister("9XdgS", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<5a7bb06770f2b343c8473e42d15fcb56>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0ceb5a87a1ab66b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ByLineContributors_contentContributors",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "count"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrentUserContributor"
        },
        {
            "kind": "ScalarField",
            "name": "isOwnerContributor"
        },
        {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        }
                    ],
                    "type": "KnownUser"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "profilePicture",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ContentContributors"
};
$b0ceb5a87a1ab66b$var$node.hash = "779053a535fff2e4b879239a0c659d33";
var $b0ceb5a87a1ab66b$export$2e2bcd8739ae039 = $b0ceb5a87a1ab66b$var$node;


/**
 * @generated SignedSource<<25ece5b7c7619089c2671980ba9d77b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $02a8f9783e035b58$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                }
            ],
            "type": "KnownUser"
        },
        {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "profilePicture",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "path"
                }
            ]
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "number"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "value"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "useNewContentTopper"
            }
        ],
        "kind": "Fragment",
        "name": "ByLine_content",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "useReadTime_content"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "subType"
            },
            {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "createdDate"
                    },
                    {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": v2 /*: any*/ 
                    },
                    {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": v2 /*: any*/ 
                    },
                    {
                        "kind": "LinkedField",
                        "name": "lastOwnedBy",
                        "plural": false,
                        "selections": v2 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": v2 /*: any*/ 
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "when"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "contentTypeModified"
                    }
                ]
            },
            {
                "concreteType": "ContentProperties",
                "kind": "LinkedField",
                "name": "contentProperties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "PublishedContentProperties",
                        "kind": "LinkedField",
                        "name": "latest",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "generatedBy"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "RendererContentState_content"
            },
            {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "pageTitlePublished",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "page-title-property-published"
                            }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JsonContentProperty",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    {
                                        "concreteType": "Version",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "properties(key:\"page-title-property-published\")"
                    }
                ]
            },
            {
                "alias": "editorProperty",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "editor"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v4 /*: any*/ ,
                            v5 /*: any*/ 
                        ]
                    }
                ],
                "storageKey": "properties(key:\"editor\")"
            },
            {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "useNewContentTopper",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "coverPictureWidth"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$02a8f9783e035b58$var$node.hash = "fd1269cfbe0086c112aa2da64dd8ff53";
var $02a8f9783e035b58$export$2e2bcd8739ae039 = $02a8f9783e035b58$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $zalpJ = parcelRequire("zalpJ");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $jjv3l = parcelRequire("jjv3l");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $c0urc = parcelRequire("c0urc");

var $1SNEF = parcelRequire("1SNEF");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");


var $hlP5l = parcelRequire("hlP5l");








var $hekY6 = parcelRequire("hekY6");





var $jVylI = parcelRequire("jVylI");




// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d8e46f2fc87fe7$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEQU1O _0jFU0VUF4f _3iDTPbQ4SZ",
            __cmplp.isTitleCenterAligned ? "_37wbyuDIqT" : "_37wbyuzUZr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$Circle = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _0KLXruGsB2",
            __cmplp.isTitleCenterAligned ? "_39xV02NHnM" : "_39xV02Va5s",
            __cmplp.isTitleCenterAligned ? "_0jFU0VNHnM" : "_0jFU0VVa5s",
            __cmplp.isTitleCenterAligned ? "_313842dnbC _0adFHsXJux _1DCdHidnbC _2XsHFMdnbC" : "_3138424Y4b _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$LineContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2XsHFM2ADO _0adFHsFQfX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$Line1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDcjp5 _0KLXruGsB2 _39xV02QEt6 _0jFU0VEbN9 _3138421Y8M",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$Line2 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDcjp5 _0KLXruGsB2 _0jFU0VxpxF _3138421Y8M",
            __cmplp.isTitleCenterAligned ? "_39xV024qGD" : "_39xV02b1xp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$FirstRowContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$export$438daec06afefb9e = ()=>{
    const $ = (0, $bDgLe.c)(17);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)(t0);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    if (isTitleCenterAligned) {
        let t1;
        if ($[2] !== isTitleCenterAligned) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Circle, {
                isTitleCenterAligned: isTitleCenterAligned
            });
            $[2] = isTitleCenterAligned;
            $[3] = t1;
        } else t1 = $[3];
        let t2;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Line1, null);
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] !== t1) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$FirstRowContainer, null, t1, t2);
            $[5] = t1;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== isTitleCenterAligned) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Line2, {
                isTitleCenterAligned: isTitleCenterAligned
            });
            $[7] = isTitleCenterAligned;
            $[8] = t4;
        } else t4 = $[8];
        let t5;
        if ($[9] !== t3 || $[10] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$LineContainer, null, t3, t4);
            $[9] = t3;
            $[10] = t4;
            $[11] = t5;
        } else t5 = $[11];
        let t6;
        if ($[12] !== isTitleCenterAligned || $[13] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Container, {
                isTitleCenterAligned: isTitleCenterAligned
            }, t5);
            $[12] = isTitleCenterAligned;
            $[13] = t5;
            $[14] = t6;
        } else t6 = $[14];
        return t6;
    }
    let t1;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Circle, null);
        $[15] = t1;
    } else t1 = $[15];
    let t2;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Container, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$LineContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Line1, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Line2, null)));
        $[16] = t2;
    } else t2 = $[16];
    return t2;
};



var $83fWZ = parcelRequire("83fWZ");








var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $9wGTI = parcelRequire("9wGTI");


var $04VgG = parcelRequire("04VgG");


var $fImWv = parcelRequire("fImWv");





var $7om8k = parcelRequire("7om8k");


var $jmjWc = parcelRequire("jmjWc");


const $b3f1a98366675b36$export$bffecd160d81d78c = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "yzXpt",
    loader: async ()=>(await (parcelRequire("9IvbC"))).AutoConversionByLine,
    name: 'AutoConversionByLine'
});






var $jkVM2 = parcelRequire("jkVM2");


var $63EIj = parcelRequire("63EIj");








var $5sUij = parcelRequire("5sUij");


var $kSwu1 = parcelRequire("kSwu1");








var $kA6Zo = parcelRequire("kA6Zo");





var $b35Wv = parcelRequire("b35Wv");





var $hSqtY = parcelRequire("hSqtY");


var $isEtk = parcelRequire("isEtk");


var $bQm3c = parcelRequire("bQm3c");


var $5Kc7f = parcelRequire("5Kc7f");











var $bFPHx = parcelRequire("bFPHx");


const $7b10285448e39671$export$818988cb4f30ec46 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vP7ts",
    name: "ReactionsSSRLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("8r8Jg"))).Reactions
});



var $1NF8X = parcelRequire("1NF8X");


var $3FlVr = parcelRequire("3FlVr");


var $ke5Nx = parcelRequire("ke5Nx");

/**
 * @generated SignedSource<<84ffca27fbfe7c65cbcf62a794426f5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c4825abea248692$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ReactionsContentFragment_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "contentReactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            },
                            v0 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$3c4825abea248692$var$node.hash = "8f56d4c4019bf4c3d755d097e2930c4e";
var $3c4825abea248692$export$2e2bcd8739ae039 = $3c4825abea248692$var$node;


const $ec5d2b49526d7beb$export$775e4c56cd01bef0 = (0, $3c4825abea248692$export$2e2bcd8739ae039);


const $7bbeff754c7e0bdb$var$i18n = (0, $kSwu1.defineMessages)({
    addNew: {
        id: "reactions.view-page.byline.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "reactions.view-page.byline.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $7bbeff754c7e0bdb$var$ViewPageReactionsContainerCommonStyles = (0, $buxP3.xcss)({
    display: 'flex',
    clear: 'both',
    overflow: 'visible',
    maxWidth: 'unset',
    margin: 'unset',
    marginBottom: 'space.025',
    marginTop: 'space.025',
    height: '28px'
});
const $7bbeff754c7e0bdb$var$ReactionsComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { contentId: contentId, contentType: contentType, spaceId: spaceId, contentSubType: contentSubType, noFlexWrap: noFlexWrap, noRelativeContainer: noRelativeContainer, reactionsData: reactionsData } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [state] = (0, $isEtk.useContentState)();
    const { focusedPageReactionsId: focusedPageReactionsId } = (0, $ke5Nx.useReactionsQueryParams)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            rootMargin: "-100px 0px 0px 0px",
            triggerOnce: true
        };
        $[0] = t1;
    } else t1 = $[0];
    const [reactionsRef, reactionsSectionInView] = (0, $5sUij.useInView)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
            testId: "emoji-add-icon",
            color: "var(--ds-icon-subtle, #505258)",
            label: ""
        });
        $[1] = t2;
    } else t2 = $[1];
    const customIcon = t2;
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const isInViewAndNotOnServer = reactionsSectionInView && state?.isContentReady;
    let t3;
    if ($[2] !== contentId || $[3] !== contentSubType || $[4] !== contentType || $[5] !== edition || $[6] !== focusedPageReactionsId || $[7] !== formatMessage || $[8] !== noFlexWrap || $[9] !== noRelativeContainer || $[10] !== reactionsData || $[11] !== spaceId) {
        t3 = ()=>{
            if (contentType && spaceId) {
                const ReactionsLoader = focusedPageReactionsId ? (0, $1NF8X.ReactionsLoaderBackground) : (0, $7b10285448e39671$export$818988cb4f30ec46);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                    testId: "view-page-byline-reactions-wrapper",
                    "data-vc": "view-page-byline-reactions-wrapper"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ReactionsLoader, {
                    contentId: contentId,
                    location: contentType,
                    containerId: spaceId,
                    containerType: (0, $3FlVr.ReactionContainerType).SPACE,
                    contentSubType: contentSubType,
                    reactionsData: reactionsData,
                    summaryViewEnabled: true,
                    summaryViewThreshold: 1,
                    allowSelectFromSummaryView: true,
                    useButtonAlignmentStyling: true,
                    summaryViewPlacement: "bottom-start",
                    customAnalyticsAttributes: {
                        edition: edition
                    },
                    isSubtle: true,
                    reactionPickerTriggerIcon: customIcon,
                    useDefaultStyledContainer: true,
                    noFlexWrap: noFlexWrap,
                    noRelativeContainer: noRelativeContainer,
                    reactionPickerTriggerText: formatMessage($7bbeff754c7e0bdb$var$i18n.addNew),
                    hoverableSummaryView: true,
                    optimisticallyLoadSummaryEmojis: isSSR,
                    renderParticleEffectOnSummaryView: true
                }));
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null);
        };
        $[2] = contentId;
        $[3] = contentSubType;
        $[4] = contentType;
        $[5] = edition;
        $[6] = focusedPageReactionsId;
        $[7] = formatMessage;
        $[8] = noFlexWrap;
        $[9] = noRelativeContainer;
        $[10] = reactionsData;
        $[11] = spaceId;
        $[12] = t3;
    } else t3 = $[12];
    const displayReactions = t3;
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [
            $7bbeff754c7e0bdb$var$ViewPageReactionsContainerCommonStyles
        ];
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== displayReactions || $[15] !== isInViewAndNotOnServer) {
        t5 = isSSR || isInViewAndNotOnServer ? displayReactions() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null);
        $[14] = displayReactions;
        $[15] = isInViewAndNotOnServer;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== reactionsRef || $[18] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            ref: reactionsRef,
            testId: "view-page-byline-reactions",
            xcss: t4
        }, t5);
        $[17] = reactionsRef;
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
};
const $7bbeff754c7e0bdb$export$c52ae103b3391553 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        const reactions = props.reactionsContentFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7bbeff754c7e0bdb$var$ViewPageBylineReactionsFragmentReader, {
            ...props,
            reactionsContentFragmentRef: props.reactionsContentFragmentRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7bbeff754c7e0bdb$var$ReactionsComponent, props);
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NOTIFICATIONS
        }, reactions);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $7bbeff754c7e0bdb$var$ViewPageBylineReactionsFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let props;
    let reactionsContentFragmentRef;
    if ($[0] !== t0) {
        ({ reactionsContentFragmentRef: reactionsContentFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = reactionsContentFragmentRef;
    } else {
        props = $[1];
        reactionsContentFragmentRef = $[2];
    }
    const content = (0, $6SsN4.useFragment)((0, $ec5d2b49526d7beb$export$775e4c56cd01bef0), reactionsContentFragmentRef);
    let t1;
    if ($[3] !== content.contentReactionsSummary || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7bbeff754c7e0bdb$var$ReactionsComponent, {
            ...props,
            reactionsData: content.contentReactionsSummary
        });
        $[3] = content.contentReactionsSummary;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};



var $2wo33 = parcelRequire("2wo33");


var $lfBMY = parcelRequire("lfBMY");


var $cD1qu = parcelRequire("cD1qu");








var $a9SX7 = parcelRequire("a9SX7");


var $JTIzG = parcelRequire("JTIzG");


var $8h2Hn = parcelRequire("8h2Hn");








var $ad7Ou = parcelRequire("ad7Ou");


var $jC4nA = parcelRequire("jC4nA");


var $aWwYt = parcelRequire("aWwYt");


var $b2GGc = parcelRequire("b2GGc");


var $e2zD6 = parcelRequire("e2zD6");

const $577177aaf22dc1ba$var$i18n = (0, $kSwu1.defineMessages)({
    viewReceiptAction: {
        id: "agent-trust-receipt.byline-chip.view-receipt-action.non-final",
        defaultMessage: "View receipt"
    }
});
const $577177aaf22dc1ba$var$AgentTrustReceiptBylineChipButton = ({ receipt: receipt })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const chipLabel = `${receipt.scenario.label} - ${formatMessage($577177aaf22dc1ba$var$i18n.viewReceiptAction)}`;
    const openReceiptPanel = (0, $cozmU.useCallback)(()=>{
        showObjectSidebar((0, $b2GGc.createAgentTrustReceiptPanel)({
            receipt: receipt
        }), 'push');
    }, [
        receipt,
        showObjectSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
        testId: "agent-trust-receipt-byline-chip",
        onClick: openReceiptPanel
    }, chipLabel);
};
const $577177aaf22dc1ba$var$AgentTrustReceiptBylineChipInner = ({ contentId: contentId, generatedBy: generatedBy, creatorName: creatorName, createdAt: createdAt, lastUpdatedAt: lastUpdatedAt, versionNumber: versionNumber })=>{
    const receipt = (0, $cozmU.useMemo)(()=>(0, $e2zD6.resolveAgentTrustReceipt)(contentId, {
            generatedBy: generatedBy,
            creatorName: creatorName,
            createdAt: createdAt,
            lastUpdatedAt: lastUpdatedAt,
            versionNumber: versionNumber
        }), [
        contentId,
        generatedBy,
        creatorName,
        createdAt,
        lastUpdatedAt,
        versionNumber
    ]);
    if (!receipt) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($577177aaf22dc1ba$var$AgentTrustReceiptBylineChipButton, {
        receipt: receipt
    });
};
const $577177aaf22dc1ba$export$5f6967bf6f7e3690 = $577177aaf22dc1ba$var$AgentTrustReceiptBylineChipInner;



var $5vi32 = parcelRequire("5vi32");


var $6iOCg = parcelRequire("6iOCg");


var $35Exc = parcelRequire("35Exc");

















var $5ZtfK = parcelRequire("5ZtfK");

const $5783a7702ddb8025$var$loadingStyle = (0, $buxP3.xcss)({
    width: '85px',
    backgroundColor: 'color.skeleton.subtle',
    height: '24px',
    borderRadius: 'radius.full'
});
const $5783a7702ddb8025$var$lastUpdateStyles = (0, $buxP3.xcss)({
    marginTop: 'space.025',
    marginLeft: 'space.100',
    marginRight: 'space.150'
});
const $5783a7702ddb8025$var$i18n = (0, $kSwu1.defineMessages)({
    lastUpdateIconLabel: {
        id: "content-header.by-line.live-pages.last.updated.icon.label",
        defaultMessage: "Last updated"
    }
});
const $5783a7702ddb8025$export$b76f09da983efdc2 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { version: version, loading: loading } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($5783a7702ddb8025$var$i18n.lastUpdateIconLabel);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: t1,
            color: "var(--ds-text-subtle, #505258)",
            testId: "last-updated-icon"
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== loading || $[5] !== version) {
        t3 = loading && !version.friendlyWhen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $5783a7702ddb8025$var$loadingStyle,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null)) : version?.friendlyWhen;
        $[4] = loading;
        $[5] = version;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            gap: "space.075",
            xcss: $5783a7702ddb8025$var$lastUpdateStyles,
            testId: "live-page-last-updated"
        }, t2, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
});



var $aKxcs = parcelRequire("aKxcs");


var $5YSiR = parcelRequire("5YSiR");


var $3TrzI = parcelRequire("3TrzI");

const $22b7bc4596013b99$var$bylineLastUpdatedStyles = (0, $buxP3.xcss)({
    marginTop: 'space.negative.025',
    marginLeft: 'space.negative.050',
    marginRight: 'space.negative.075'
});
const $22b7bc4596013b99$var$ReadTimeWithContentFragmentRef = (0, $04VgG.ReadTime);
// Downstream packages are checked against the last generated confluence-analytics declaration.
const $22b7bc4596013b99$var$AnalyticsByLineWithFragmentRef = (0, $fImWv.AnalyticsByLine);
const $22b7bc4596013b99$export$773979b66159aa2 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { contentId: contentId, author: author, owner: owner, version: version, contributorsCount: contributorsCount, isOwnerContributor: isOwnerContributor, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, isFabricPage: isFabricPage, titleContentProperties: titleContentProperties, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, contentSubType: contentSubType, spaceId: spaceId, generatedBy: generatedBy, connectionAncestors: connectionAncestors, createdDate: createdDate, contentFragmentRef: contentFragmentRef, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef } = t0;
    const isRestrictedExternalShare = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const [contentTypeFromContext] = (0, $ep3mz.useContentType)();
    const { isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    const t1 = contentType ?? contentTypeFromContext;
    let t2;
    if ($[0] !== contentId || $[1] !== t1) {
        t2 = {
            contentId: contentId,
            contentType: t1,
            operation: (0, $lfBMY.OperationTypes).UPDATE,
            status: (0, $cD1qu.CURRENT_STATUS)
        };
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const canUpdateContent = (0, $2wo33.useCanPerformContentOperation)(t2);
    const hasEditPermission = canUpdateContent ?? false;
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const showByLineContributors = hasByLineContributors ?? true;
    const showByLineExtensions = hasByLineExtensions ?? true;
    let t3;
    if ($[3] !== generatedBy) {
        t3 = generatedBy === (0, $3TrzI.AI_PLANNER_GENERATED_BY) && (0, $9wGTI.fg)("confluence_ai_planner_sync_byline");
        $[3] = generatedBy;
        $[4] = t3;
    } else t3 = $[4];
    const shouldRenderAIPlannerSyncByline = t3;
    const BylineMainDiv = (0, $6mKj3.expValEquals)("confluence_byline_min_height", "isEnabled", true) ? (0, $35Exc.StandardPageBylineStyledMainDiv) : (0, $35Exc.StyledMainDiv);
    let t4;
    if ($[5] !== author || $[6] !== bylineClassificationFragmentRef || $[7] !== contentClassificationFragmentRef || $[8] !== contentFragmentRef || $[9] !== contentId || $[10] !== contentType || $[11] !== contentTypeFromContext || $[12] !== contributorsCount || $[13] !== generatedBy || $[14] !== hasEditPermission || $[15] !== isFabricPage || $[16] !== isOwnerContributor || $[17] !== owner || $[18] !== showByLineContributors || $[19] !== version) {
        t4 = showByLineContributors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
            owner: owner,
            author: author,
            analyticsSource: "renderer",
            contributorCountWithoutOwner: contributorsCount - (isOwnerContributor ? 1 : 0),
            generatedBy: generatedBy
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKxcs.BylineClassification), {
            contentId: contentId,
            classificationContextFragmentRef: bylineClassificationFragmentRef,
            contentFragmentRef: contentClassificationFragmentRef
        }), (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jkVM2.EditorContentState), {
            contentId: contentId,
            contentType: contentType ?? contentTypeFromContext,
            isViewMode: true,
            canEdit: hasEditPermission,
            userOffline: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63EIj.RendererContentState), {
            contentId: contentId,
            isDraft: false,
            hasSeparator: false,
            contentFragmentRef: contentFragmentRef
        }), !isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $22b7bc4596013b99$var$bylineLastUpdatedStyles,
            testId: "page-last-modified"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5783a7702ddb8025$export$b76f09da983efdc2), {
            version: version
        })));
        $[5] = author;
        $[6] = bylineClassificationFragmentRef;
        $[7] = contentClassificationFragmentRef;
        $[8] = contentFragmentRef;
        $[9] = contentId;
        $[10] = contentType;
        $[11] = contentTypeFromContext;
        $[12] = contributorsCount;
        $[13] = generatedBy;
        $[14] = hasEditPermission;
        $[15] = isFabricPage;
        $[16] = isOwnerContributor;
        $[17] = owner;
        $[18] = showByLineContributors;
        $[19] = version;
        $[20] = t4;
    } else t4 = $[20];
    let t5;
    if ($[21] !== contentId || $[22] !== contentType || $[23] !== contentTypeFromContext || $[24] !== generatedBy || $[25] !== isEmbeddedConfluence || $[26] !== shouldRenderAIPlannerSyncByline) {
        t5 = shouldRenderAIPlannerSyncByline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5YSiR.LazyAIPlannerSyncByline), {
            contentId: contentId,
            contentType: contentType ?? contentTypeFromContext,
            generatedBy: generatedBy,
            isEmbeddedConfluence: isEmbeddedConfluence
        });
        $[21] = contentId;
        $[22] = contentType;
        $[23] = contentTypeFromContext;
        $[24] = generatedBy;
        $[25] = isEmbeddedConfluence;
        $[26] = shouldRenderAIPlannerSyncByline;
        $[27] = t5;
    } else t5 = $[27];
    let t6;
    if ($[28] !== analyticsBylineFragmentRef || $[29] !== author || $[30] !== connectionAncestors || $[31] !== contentFragmentRef || $[32] !== contentId || $[33] !== contentSubType || $[34] !== contentType || $[35] !== createdDate || $[36] !== generatedBy || $[37] !== isAudioBylineEntrypointEnabled || $[38] !== isRestrictedExternalShare || $[39] !== reactionsContentFragmentRef || $[40] !== shouldShowBylineReactions || $[41] !== showByLineExtensions || $[42] !== spaceId || $[43] !== version?.number || $[44] !== version?.when) {
        t6 = showByLineExtensions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22b7bc4596013b99$var$ReadTimeWithContentFragmentRef, {
            contentId: contentId,
            contentFragmentRef: contentFragmentRef
        }), (0, $9wGTI.fg)("cc_sparks_agent_trust_receipt") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $577177aaf22dc1ba$export$5f6967bf6f7e3690), {
            contentId: contentId,
            generatedBy: generatedBy,
            creatorName: author?.fullName,
            createdAt: createdDate,
            lastUpdatedAt: version?.when,
            versionNumber: version?.number
        }), (0, $6mKj3.isExperimentEnabled)("confluence_1p_and_3p_connection_byline_experiment") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8h2Hn.BylineConnections), {
            contentId: contentId,
            connectionAncestors: connectionAncestors,
            pageVersion: version?.number,
            pageUpdatedAt: version?.when
        }), isAudioBylineEntrypointEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9SX7.ListenByline), {
            contentId: contentId,
            contentType: contentType ?? undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22b7bc4596013b99$var$AnalyticsByLineWithFragmentRef, {
            contentId: contentId,
            contentAuthorId: author.userId,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef
        }), shouldShowBylineReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7bbeff754c7e0bdb$export$c52ae103b3391553), {
            contentId: contentId,
            contentType: contentType,
            spaceId: spaceId,
            contentSubType: contentSubType,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            noFlexWrap: true,
            noRelativeContainer: true
        }), !isRestrictedExternalShare && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3f1a98366675b36$export$bffecd160d81d78c), null));
        $[28] = analyticsBylineFragmentRef;
        $[29] = author;
        $[30] = connectionAncestors;
        $[31] = contentFragmentRef;
        $[32] = contentId;
        $[33] = contentSubType;
        $[34] = contentType;
        $[35] = createdDate;
        $[36] = generatedBy;
        $[37] = isAudioBylineEntrypointEnabled;
        $[38] = isRestrictedExternalShare;
        $[39] = reactionsContentFragmentRef;
        $[40] = shouldShowBylineReactions;
        $[41] = showByLineExtensions;
        $[42] = spaceId;
        $[43] = version?.number;
        $[44] = version?.when;
        $[45] = t6;
    } else t6 = $[45];
    let t7;
    if ($[46] !== contentId || $[47] !== isTitleCenterAligned || $[48] !== showByLineExtensions || $[49] !== t4 || $[50] !== t5 || $[51] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35Exc.StyledTextDiv), {
            hasBadgeStylePageOwnerBylineItem: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6iOCg.SingleLineByLine), {
            contentId: contentId,
            isTitleCenterAlignedOverride: isTitleCenterAligned,
            showByLineExtensions: showByLineExtensions
        }, t4, t5, t6));
        $[46] = contentId;
        $[47] = isTitleCenterAligned;
        $[48] = showByLineExtensions;
        $[49] = t4;
        $[50] = t5;
        $[51] = t6;
        $[52] = t7;
    } else t7 = $[52];
    let t8;
    if ($[53] !== isTitleCenterAligned || $[54] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BylineMainDiv, {
            className: "page-metadata-modification-info",
            "data-testid": "page-main-div",
            isTitleCenterAligned: isTitleCenterAligned
        }, t7);
        $[53] = isTitleCenterAligned;
        $[54] = t7;
        $[55] = t8;
    } else t8 = $[55];
    return t8;
});



var $9HhEw = parcelRequire("9HhEw");

const $3ade7df4fa86d9cd$export$83e33e2cb03d444b = (0, $9HhEw.default);


const $0559514361f7ee96$export$f2d7ca777241edb7 = (0, $02a8f9783e035b58$export$2e2bcd8739ae039);
const $0559514361f7ee96$export$4aabfa7af1f71de0 = (0, $b0ceb5a87a1ab66b$export$2e2bcd8739ae039);
// WARN: This is temporary code to send analytics event when we would crash the part
// of the ByLine experience when byline user is undefined due to any reason.
// This is done as part of https://ops.internal.atlassian.com/jira/browse/HOT-106424
// investigation. This code should be removed once we know the root cause/impact.
const $0559514361f7ee96$var$HOT106424Tracker = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { content: content, contentId: contentId, contentContributors: contentContributors, isExternalShareRequest: isExternalShareRequest } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== content || $[1] !== contentContributors?.nodes || $[2] !== contentId || $[3] !== createAnalyticsEvent || $[4] !== isExternalShareRequest) {
        t1 = ()=>{
            const byUser = content?.version?.by;
            const createdBy = content?.history?.createdBy;
            const hasEmptyContributors = (contentContributors?.nodes || []).some($0559514361f7ee96$var$_temp);
            const contentHistory = content?.history;
            const createdDate = content?.history?.createdDate;
            if (hasEmptyContributors || !createdBy || !byUser) createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    source: "byLine",
                    action: "byLineUserEmpty",
                    actionSubject: "content",
                    attributes: {
                        contentId: contentId,
                        isExternalShareRequest: isExternalShareRequest,
                        hasEmptyContributors: hasEmptyContributors,
                        hasCreatedBy: Boolean(createdBy),
                        hasByUser: Boolean(byUser),
                        hasContent: Boolean(content),
                        hasHistory: Boolean(contentHistory),
                        hasCreatedDate: Boolean(createdDate)
                    }
                }
            }).fire();
        };
        $[0] = content;
        $[1] = contentContributors?.nodes;
        $[2] = contentId;
        $[3] = createAnalyticsEvent;
        $[4] = isExternalShareRequest;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== content || $[7] !== contentContributors || $[8] !== contentId || $[9] !== createAnalyticsEvent || $[10] !== isExternalShareRequest) {
        t2 = [
            content,
            contentId,
            contentContributors,
            createAnalyticsEvent,
            isExternalShareRequest
        ];
        $[6] = content;
        $[7] = contentContributors;
        $[8] = contentId;
        $[9] = createAnalyticsEvent;
        $[10] = isExternalShareRequest;
        $[11] = t2;
    } else t2 = $[11];
    (0, $cozmU.useEffect)(t1, t2);
    return null;
};
const $0559514361f7ee96$export$3da174e1e9f9b5b4 = (t0)=>{
    const $ = (0, $bDgLe.c)(69);
    let analyticsBylineFragmentRef;
    let bylineClassificationFragmentRef;
    let contentClassificationFragmentRef;
    let contentContributors;
    let contentFragmentRef;
    let contentId;
    let contentSubType;
    let contentType;
    let passThroughProps;
    let reactionsContentFragmentRef;
    let shouldShowBylineReactions;
    let spaceId;
    if ($[0] !== t0) {
        ({ contentFragmentRef: contentFragmentRef, contentContributors: contentContributors, contentId: contentId, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, spaceId: spaceId, contentSubType: contentSubType, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = analyticsBylineFragmentRef;
        $[2] = bylineClassificationFragmentRef;
        $[3] = contentClassificationFragmentRef;
        $[4] = contentContributors;
        $[5] = contentFragmentRef;
        $[6] = contentId;
        $[7] = contentSubType;
        $[8] = contentType;
        $[9] = passThroughProps;
        $[10] = reactionsContentFragmentRef;
        $[11] = shouldShowBylineReactions;
        $[12] = spaceId;
    } else {
        analyticsBylineFragmentRef = $[1];
        bylineClassificationFragmentRef = $[2];
        contentClassificationFragmentRef = $[3];
        contentContributors = $[4];
        contentFragmentRef = $[5];
        contentId = $[6];
        contentSubType = $[7];
        contentType = $[8];
        passThroughProps = $[9];
        reactionsContentFragmentRef = $[10];
        shouldShowBylineReactions = $[11];
        spaceId = $[12];
    }
    const content = (0, $6SsN4.useFragment)($0559514361f7ee96$export$f2d7ca777241edb7, contentFragmentRef);
    const contentContributorsData = (0, $6SsN4.useFragment)($0559514361f7ee96$export$4aabfa7af1f71de0, contentContributors ?? null);
    if (!content) return null;
    const t1 = content.history?.createdBy;
    let t2;
    if ($[13] !== t1) {
        t2 = (0, $83fWZ.toUserProps)(t1);
        $[13] = t1;
        $[14] = t2;
    } else t2 = $[14];
    const author = t2;
    let t3;
    if ($[15] !== content.history?.ownedBy || $[16] !== content.type) {
        t3 = content.history?.ownedBy && (content.type === "page" || content.type === "blogpost") ? (0, $83fWZ.toUserProps)(content.history?.ownedBy) : null;
        $[15] = content.history?.ownedBy;
        $[16] = content.type;
        $[17] = t3;
    } else t3 = $[17];
    const owner = t3;
    const t4 = content.version?.by;
    let t5;
    if ($[18] !== t4) {
        t5 = (0, $83fWZ.toUserProps)(t4);
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    const by = t5;
    const contributorsCount = contentContributorsData?.count || 0;
    const isOwnerContributor = contentContributorsData?.isOwnerContributor || false;
    let t6;
    if ($[20] !== content.editorProperty?.nodes) {
        const editorVersion = content.editorProperty?.nodes?.find($0559514361f7ee96$var$_temp2);
        t6 = editorVersion?.value?.includes("v2") || false;
        $[20] = content.editorProperty?.nodes;
        $[21] = t6;
    } else t6 = $[21];
    const isFabricPage = t6;
    let t7;
    if ($[22] !== content) {
        t7 = (0, $zalpJ.getTitleContentProperty)({
            content: {
                nodes: [
                    content
                ]
            }
        });
        $[22] = content;
        $[23] = t7;
    } else t7 = $[23];
    const { titleContentProperties: titleContentProperties } = t7;
    const generatedBy = content.contentProperties?.latest?.generatedBy;
    let t8;
    let t9;
    if ($[24] !== contentId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.VIEW_PAGE_BYLINE_EXPERIENCE),
            id: contentId
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC)
        });
        $[24] = contentId;
        $[25] = t8;
        $[26] = t9;
    } else {
        t8 = $[25];
        t9 = $[26];
    }
    const t10 = content.history?.createdDate || null;
    const t11 = content.version?.friendlyWhen || "";
    const t12 = content.version?.when || null;
    const t13 = Number(content.version?.number || "");
    const t14 = content.version?.contentTypeModified || false;
    let t15;
    if ($[27] !== by || $[28] !== t11 || $[29] !== t12 || $[30] !== t13 || $[31] !== t14) {
        t15 = {
            friendlyWhen: t11,
            when: t12,
            number: t13,
            by: by,
            contentTypeModified: t14
        };
        $[27] = by;
        $[28] = t11;
        $[29] = t12;
        $[30] = t13;
        $[31] = t14;
        $[32] = t15;
    } else t15 = $[32];
    let t16;
    if ($[33] !== analyticsBylineFragmentRef || $[34] !== author || $[35] !== bylineClassificationFragmentRef || $[36] !== content || $[37] !== contentClassificationFragmentRef || $[38] !== contentId || $[39] !== contentSubType || $[40] !== contentType || $[41] !== contributorsCount || $[42] !== generatedBy || $[43] !== isFabricPage || $[44] !== isOwnerContributor || $[45] !== owner || $[46] !== passThroughProps || $[47] !== reactionsContentFragmentRef || $[48] !== shouldShowBylineReactions || $[49] !== spaceId || $[50] !== t10 || $[51] !== t15 || $[52] !== titleContentProperties) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22b7bc4596013b99$export$773979b66159aa2), {
            contentId: contentId,
            author: author,
            owner: owner,
            contributorsCount: contributorsCount,
            isOwnerContributor: isOwnerContributor,
            isFabricPage: isFabricPage,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentSubType: contentSubType,
            spaceId: spaceId,
            contentType: contentType,
            titleContentProperties: titleContentProperties,
            generatedBy: generatedBy,
            connectionAncestors: null,
            createdDate: t10,
            contentFragmentRef: content,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef,
            version: t15,
            ...passThroughProps
        });
        $[33] = analyticsBylineFragmentRef;
        $[34] = author;
        $[35] = bylineClassificationFragmentRef;
        $[36] = content;
        $[37] = contentClassificationFragmentRef;
        $[38] = contentId;
        $[39] = contentSubType;
        $[40] = contentType;
        $[41] = contributorsCount;
        $[42] = generatedBy;
        $[43] = isFabricPage;
        $[44] = isOwnerContributor;
        $[45] = owner;
        $[46] = passThroughProps;
        $[47] = reactionsContentFragmentRef;
        $[48] = shouldShowBylineReactions;
        $[49] = spaceId;
        $[50] = t10;
        $[51] = t15;
        $[52] = titleContentProperties;
        $[53] = t16;
    } else t16 = $[53];
    let t17;
    if ($[54] !== contributorsCount) {
        t17 = {
            contributorsCount: contributorsCount
        };
        $[54] = contributorsCount;
        $[55] = t17;
    } else t17 = $[55];
    let t18;
    if ($[56] !== contentId || $[57] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC),
            customData: t17
        });
        $[56] = contentId;
        $[57] = t17;
        $[58] = t18;
    } else t18 = $[58];
    let t19;
    if ($[59] !== content || $[60] !== contentContributorsData || $[61] !== contentId) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0559514361f7ee96$var$HOT106424Tracker, {
            content: content,
            contentId: contentId,
            contentContributors: contentContributorsData,
            isExternalShareRequest: false
        });
        $[59] = content;
        $[60] = contentContributorsData;
        $[61] = contentId;
        $[62] = t19;
    } else t19 = $[62];
    let t20;
    if ($[63] !== t16 || $[64] !== t18 || $[65] !== t19 || $[66] !== t8 || $[67] !== t9) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        }, t8, t9, t16, t18, t19);
        $[63] = t16;
        $[64] = t18;
        $[65] = t19;
        $[66] = t8;
        $[67] = t9;
        $[68] = t20;
    } else t20 = $[68];
    return t20;
};
const $0559514361f7ee96$export$3b7993d3cbe5f289 = (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { contentId: contentId, versionOverride: versionOverride, embeddedContentRender: embeddedContentRender, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, spaceId: spaceId, contentSubType: contentSubType, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, ...passThroughProps } = t0;
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isRestrictedExternalShare = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const t1 = versionOverride || null;
    const t2 = embeddedContentRender || null;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $6mKj3.expValEquals)("cc-markdown-mode", "isEnabled", true);
        t4 = (0, $6mKj3.isExperimentEnabled)("confluence_1p_and_3p_connection_byline_experiment");
        $[0] = t3;
        $[1] = t4;
    } else {
        t3 = $[0];
        t4 = $[1];
    }
    let t5;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t1 || $[5] !== t2) {
        t5 = {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: t1,
            embeddedContentRender: t2,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            useNewContentTopper: true,
            isMarkdownModeEnabled: t3,
            includeDevDocsBylineConnection: t4
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t1;
        $[5] = t2;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            allowOnExternalPage: true,
            single: true
        };
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== t5) {
        t7 = {
            variables: t5,
            context: t6
        };
        $[8] = t5;
        $[9] = t7;
    } else t7 = $[9];
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)(isRestrictedExternalShare ? (0, $3ade7df4fa86d9cd$export$83e33e2cb03d444b) : (0, $fxLAA.default), {
        ...t7,
        __callerPackage__: "content-header"
    });
    let t8;
    if ($[10] !== contentId || $[11] !== refetch) {
        t8 = ()=>refetch({
                contentId: contentId,
                cacheBuster: ""
            });
        $[10] = contentId;
        $[11] = refetch;
        $[12] = t8;
    } else t8 = $[12];
    const reload = t8;
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = [
            (0, $c0urc.ReloadType).content
        ];
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== reload) {
        t10 = {
            name: "byline",
            types: t9,
            reload: reload
        };
        $[14] = reload;
        $[15] = t10;
    } else t10 = $[15];
    (0, $1SNEF.useQuickReloadSubscriber)(t10);
    const renderByLine = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1d8e46f2fc87fe7$export$438daec06afefb9e), null);
        const content = isRestrictedExternalShare ? data?.singleContent : data?.content?.nodes?.[0];
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return null;
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
        } else {
            if (!content) return null;
        }
        const author = (0, $83fWZ.toUserProps)(content?.history?.createdBy);
        const owner = content?.history?.ownedBy && (content?.type === "page" || content?.type === "blogpost") ? (0, $83fWZ.toUserProps)(content?.history?.ownedBy) : null;
        const by = (0, $83fWZ.toUserProps)(content?.version?.by);
        const contributorsCount = data?.contentContributors?.count || 0;
        const isOwnerContributor = data?.contentContributors?.isOwnerContributor || false;
        const isFabricPage = !isRestrictedExternalShare ? (0, $83fWZ.isFabricEditor)(data) : false;
        const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(data);
        const contentHeaderContent = !isRestrictedExternalShare ? data?.content?.nodes?.[0] : null;
        const generatedBy = contentHeaderContent?.contentProperties?.latest?.generatedBy;
        const connectionAncestors = contentHeaderContent?.ancestors ?? null;
        const componentProps = {
            contentId: contentId,
            author: author,
            owner: owner,
            contributorsCount: contributorsCount,
            isOwnerContributor: isOwnerContributor,
            isFabricPage: isFabricPage,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentSubType: contentSubType,
            spaceId: spaceId,
            contentType: contentType,
            titleContentProperties: titleContentProperties,
            generatedBy: generatedBy,
            connectionAncestors: connectionAncestors,
            createdDate: content?.history?.createdDate || null,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef,
            version: {
                friendlyWhen: content?.version?.friendlyWhen || "",
                when: content?.version?.when || null,
                number: Number(content?.version?.number || ""),
                by: by,
                contentTypeModified: content?.version?.contentTypeModified || false
            },
            ...passThroughProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22b7bc4596013b99$export$773979b66159aa2), componentProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC),
            customData: {
                contributorsCount: contributorsCount
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0559514361f7ee96$var$HOT106424Tracker, {
            content: content,
            contentId: contentId,
            contentContributors: data?.contentContributors,
            isExternalShareRequest: isRestrictedExternalShare
        }));
    };
    const T0 = (0, $4PPzL.ErrorBoundary);
    const t11 = (0, $3IBnw.Attribution);
    let t12;
    let t13;
    if ($[16] !== contentId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.VIEW_PAGE_BYLINE_EXPERIENCE),
            id: contentId
        });
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC)
        });
        $[16] = contentId;
        $[17] = t12;
        $[18] = t13;
    } else {
        t12 = $[17];
        t13 = $[18];
    }
    const t14 = renderByLine();
    let t15;
    if ($[19] !== T0 || $[20] !== t11.BACKBONE || $[21] !== t12 || $[22] !== t13 || $[23] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            attribution: t11.BACKBONE
        }, t12, t13, t14);
        $[19] = T0;
        $[20] = t11.BACKBONE;
        $[21] = t12;
        $[22] = t13;
        $[23] = t14;
        $[24] = t15;
    } else t15 = $[24];
    return t15;
};
function $0559514361f7ee96$var$_temp(node) {
    return !node;
}
function $0559514361f7ee96$var$_temp2(property) {
    return property?.key === "editor";
}
module.exports["ByLineFromFragment"] = $0559514361f7ee96$export$3da174e1e9f9b5b4;
module.exports["ByLine"] = $0559514361f7ee96$export$3b7993d3cbe5f289;

});

parcelRegister("87We3", function(module, exports) {

var $9fBoq = parcelRequire("9fBoq");

const $deb788b04f754a67$export$f3f60ff46f4bf02b = (snapshot)=>snapshot.completeness === 'complete' && snapshot.producers.connect === 'complete' && snapshot.producers.forge === 'complete' && snapshot.apps.every(({ presentation: presentation })=>presentation.resolution === 'resolved');
const $deb788b04f754a67$var$getProducerStatus = ({ error: error, hasItems: hasItems, loading: loading })=>{
    if (error) return 'failed';
    if (loading && !hasItems) return 'pending';
    return 'complete';
};
const $deb788b04f754a67$var$getCompleteness = (connect, forge)=>{
    if (connect === 'complete' && forge === 'complete') return 'complete';
    if (connect === 'failed' && forge === 'failed') return 'failed';
    return 'partial';
};
const $deb788b04f754a67$export$d1d89135a42756e9 = ({ connectError: connectError, connectItems: connectItems, forgeError: forgeError, forgeItems: forgeItems, loadingConnectItems: loadingConnectItems, loadingForgeItems: loadingForgeItems })=>{
    const connectStatus = $deb788b04f754a67$var$getProducerStatus({
        error: connectError,
        hasItems: connectItems.length > 0,
        loading: loadingConnectItems
    });
    const forgeStatus = $deb788b04f754a67$var$getProducerStatus({
        error: forgeError,
        hasItems: forgeItems.length > 0,
        loading: loadingForgeItems
    });
    const connectApps = connectItems.map((item, order)=>({
            id: item.completeKey || item.id || `connect-${order}`,
            order: order,
            producer: 'connect',
            presentation: {
                ...item.icon?.path ? {
                    icon: {
                        height: item.icon.height ?? 14,
                        src: item.icon.path,
                        width: item.icon.width ?? 14
                    }
                } : {},
                label: item.label ?? '',
                resolution: 'resolved',
                source: 'connectWebItem',
                ...item.tooltip ? {
                    tooltip: item.tooltip
                } : {}
            }
        }));
    const forgeApps = forgeItems.map((app, index)=>{
        const contentPropertyKey = app.properties.contentPropertyKey;
        const hasDynamicProperties = Boolean(app.properties.dynamicProperties);
        const isManifestStatic = !contentPropertyKey && !hasDynamicProperties;
        return {
            id: app.id,
            order: connectApps.length + index,
            producer: 'forge',
            presentation: {
                ...app.properties.icon ? {
                    icon: {
                        height: 14,
                        src: app.properties.icon,
                        width: 14
                    }
                } : {},
                label: app.properties.title ? (0, $9fBoq.extensionTitle)(app) : '',
                resolution: isManifestStatic && Boolean(app.properties.title) ? 'resolved' : 'unresolved',
                source: contentPropertyKey ? 'contentProperty' : hasDynamicProperties ? 'dynamicProperties' : 'manifest',
                ...app.properties.tooltip ? {
                    tooltip: app.properties.tooltip
                } : {}
            }
        };
    });
    return {
        apps: [
            ...connectApps,
            ...forgeApps
        ],
        completeness: $deb788b04f754a67$var$getCompleteness(connectStatus, forgeStatus),
        producers: {
            connect: connectStatus,
            forge: forgeStatus
        }
    };
};
module.exports["isByLineAppSnapshotAuthoritative"] = $deb788b04f754a67$export$f3f60ff46f4bf02b;
module.exports["createByLineAppSnapshot"] = $deb788b04f754a67$export$d1d89135a42756e9;

});

parcelRegister("35Exc", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $0adb659d8e3039a1$export$c008670b78f0cf4f = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg7NXe _2XghbEQU1O _1UtDYzZpcK _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.isTitleCenterAligned ? "_2fwxA5DIqT" : "_2fwxA5OLYo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$export$8360598613515efc = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$export$c008670b78f0cf4f : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4kiQYAS40j",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0adb659d8e3039a1$export$3ed1f5d7ee09c27 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$export$c008670b78f0cf4f : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEPgdg _0hPCNLDIqT _2O5Vij7dHp _42Yu6BgtVO _1ANEUSLRg7",
            !!__cmplp.hasFixedHeight ? "_0jFU0VUofl" : "_0jFU0VIZbP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$var$BylineStyledMainDivSingleLineWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let children;
    let props;
    if ($[0] !== t0) {
        const { isExpanded: isExpanded, children: t1, ...t2 } = t0;
        children = t1;
        props = t2;
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0adb659d8e3039a1$export$3ed1f5d7ee09c27, props, children);
        $[3] = children;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
}; /* eslint-enable @typescript-eslint/no-unused-vars */ 
const $0adb659d8e3039a1$export$b95808ab42b44324 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$var$BylineStyledMainDivSingleLineWrapper : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02N91d _1mT5xdRAKS _42Yu6BIZbP",
            __cmplp.isExpanded ? "_00U5WxHZdu" : "_00U5WxdnbC",
            __cmplp.isExpanded ? "_4afKC8A17z" : "_4afKC8dnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$export$6a3337cf751e21ac = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { hasBadgeStylePageOwnerBylineItem: hasBadgeStylePageOwnerBylineItem, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02N91d _0luBOg98eZ _2h5UOzYbGa _3W2WEt6wH8 _0gKGieM7Tp _0uGipI98eZ _0DlTgX98eZ _1Oh6lc98eZ _1KbF3r98eZ _2LQVB40Rl6 _27PHXJ0Rl6 _38ddKy0Rl6 _1R2oCZ0Rl6 _4BW6TR6wH8 _2IWu1s6wH8 _4i4dA66wH8 _06nYrP6wH8 _1EjoPeAwSC _1BrKNsAwSC _1E1xWzAwSC _3bFj0TAwSC",
            !!__cmplp.hasBadgeStylePageOwnerBylineItem ? "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC" : "_2XghbE8UTm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0adb659d8e3039a1$export$5237d2d172029aad = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$export$6a3337cf751e21ac : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _313842FQfX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["StyledMainDiv"] = $0adb659d8e3039a1$export$c008670b78f0cf4f;
module.exports["StandardPageBylineStyledMainDiv"] = $0adb659d8e3039a1$export$8360598613515efc;
module.exports["BylineStyledMainDivSingleLine"] = $0adb659d8e3039a1$export$b95808ab42b44324;
module.exports["StyledTextDiv"] = $0adb659d8e3039a1$export$6a3337cf751e21ac;

});


//# sourceMappingURL=EditorByLineArea.e0777090.js.map
